<template>
  <div id="content" class="internalAssessment">
    <CreateCriteriaModal :dialogVisible='dialog' @close="dialog = false" @newCriteriaCreated="newCriteriaCreated($event)"></CreateCriteriaModal>
    <UpdateCriteriaModal :dialogVisible='dialogUpdate' :toupdate="toupdate" @close="dialogUpdate = false" @newCriteriaUpdate="newCriteriaCreated($event)"></UpdateCriteriaModal>
    <UpdateNameModal :dialogVisible='dialogUpdateNameModal' @close="dialogUpdateNameModal = false" @newValueIsProposed="setNewGroupName($event)" formName="Edit your criteria group" :projectName="ask_for_edit.name" ></UpdateNameModal>

    <div class="container" v-if="step == 6">
      <div class="internalAssessment_inner tcenter">
        <div class="thank_you_container">
          <div class="thank_you">
            <div class="titre_1">
                Congratulations on completing the assessment setup
            </div>
            <div class="text_1">
              <p>The invitations have been successfully sent to the judges.</p>

            <p>  You may still add additional judges at any time prior to the deadline.<br/>
New invites will only be sent to additional judges.
</p>

            </div>
            <div class="image_1">
              <img :src="require('@/assets/thanyouimage.png')" alt="">
            </div>
          </div>

        </div>
      </div>

    </div>

    <div class="container" v-else>
      <div class="assessment-navigation">
        <div class="left">
          <router-link to="/manage_assessments" class="back-button" >

            <v-img :src="require('@/assets/backArrowBlue.svg')" alt=""></v-img>
            Back
          </router-link>
                      <span class="aname" v-if="internalAssessment.name"> {{ internalAssessment.name }}</span>
                      <span class="aname" v-else>{{ $t("My assessment")}}</span>
          <div class="status inprogress" v-if="internalAssessment.status == 'progress'">
              <span class="status-text">{{ $t("In progress")}}</span>

          </div>
          <div class="status draft" v-if="internalAssessment.status == 'draft'">
              <span class="status-text">{{ $t("Draft")}}</span>

          </div>
          <div class="status completed" v-if="internalAssessment.status == 'completed'">
              <span class="status-text">{{ $t("Completed")}}</span>

          </div>
          <div class="status closed" v-if="internalAssessment.status == 'closed'">
              <span class="status-text">{{ $t("Closed")}}</span>

          </div>
        </div>
        <div class="right" v-if="internalAssessment">
          <!-- <router-link class="preview-button" :to="'/internalassessment_preview/'+internalAssessment._id.$oid+'?step='+this.step" v-if="internalAssessment._id">
              Preview
          </router-link> -->
          <button
              class="preview-button"
              @click="handleSaveBeforeRedirect"
              v-if="internalAssessment._id"
            >
              Preview
            </button>
          <button class="next-button" @click='saveIt()' v-if="(step== 1 || step == 3 || step == 5) && (internalAssessment.status == 'draft' || internalAssessment.status == 'progress') && internalAssessment._id">
              Save
          </button>

          <button class="next-button" @click='next()' v-if="step < 5">
              Next <v-img :src="require('@/assets/next.svg')" alt=""></v-img>
          </button>

          <button class="next-button" @click='sendInvit()' v-if="step == 5">
              Send <v-img :src="require('@/assets/next.svg')" alt=""></v-img>
          </button>
        </div>

    </div>

      <div class="internalAssessment_inner mt20">




        <div class="step-progress">
            <div class="step" :class="{'current': step == 1}" @click="goToStep(1)">
                <div class="step-number " :class="{'active': step == 1, 'done' :step > 1 || internalAssessment.name.length > 0}">01</div>
                <div class="step-label">{{ $t("Assessment Scope")}}</div>
            </div>
            <div class="step-line">

            </div>
            <div class="step" @click="goToStep(2)"  :class="{'current': step == 2}" >
                <div class="step-number" :class="{'active': step == 2, 'done' :step > 2 || internalAssessment.criterias.length > 0}">02</div>
                <div class="step-label">{{ $t("Assessment Criteria")}} </div>
            </div>
            <div class="step-line">

            </div>
            <div class="step" @click="goToStep(3)"  :class="{'current': step == 3}" >
                <div class="step-number" :class="{'active': step == 3, 'done' : internalAssessment.status != 'draft' || (internalAssessment.disableFeedback || (internalAssessment.feedback_1 && internalAssessment.feedback_2 && internalAssessment.feedback_3 )) }">03</div>
                <div class="step-label">{{ $t("Additional Feedback")}}</div>
            </div>
            <div class="step-line">

            </div>
            <div class="step"  @click="goToStep(4)"  :class="{'current': step == 4}" >
                <div class="step-number"  :class="{'active': step == 4, 'done' : (step > 4 || internalAssessment.startups.length > 0)}">04</div>
                <div class="step-label">{{ $t("Innovator Selection")}}</div>
            </div>
            <div class="step-line">

            </div>
            <div class="step" @click="goToStep(5)"  :class="{'current': step == 5 }" >
                <div class="step-number" :class="{'active': step == 5, 'done' :step > 5 || internalAssessment.judges.length > 0}">05</div>
                <div class="step-label">{{ $t("Judges")}}</div>
            </div>
        </div>
        <div class="loaderInnopearl mt50" v-if="mainLoading">
          <div class="loaderInnopearlInner">
            <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
            <span>Loading in progress</span>
          </div>

        </div>
        <div class="" v-else>
      <div class="step-1 typoAssessment" v-if="step == 6">


      </div>

        <div class="step-1 typoAssessment" v-if="step == 1">
          <div class="assessment-type">
            <label class="radio-label" v-for="option in optionsType" :key="option.value">
              <input
                type="radio"
                :value="option.value"
                v-model="internalAssessment.type"
              />
              <span class="custom-radio"></span>
              <span class="radio-text">{{ option.text }}</span>
            </label>
          </div>


          <div class="basicInfo">
              <div class="" v-if="internalAssessment.type">
                <div class="row">
                  <div class="col-12 col-lg-8">

                    <div class="row">


                      <div class="col-12 col-xl-6 mt20"  v-if="internalAssessment.type == 'project'">
                        <div class="zone_input" >
                          <div class="zone_input_header">
                            <span class="zone_input_name">{{ $t("Project")}}*</span>
                          </div>
                            <select class="innopearl_input"  v-model="internalAssessment.project" @change="maybeSetName($event)">
                              <option v-for="(project, p ) in projects " :key="p" :value="project._id">{{project.name}}</option>
                            </select>
                            <!-- <v-autocomplete v-model="internalAssessment.procjet" closable-chips  :items="projects" item-color="#FFF" item-title="name" item-value="value"  chips multiple></v-autocomplete> -->

                        </div>

                      </div>
                <div class="col-12 col-xl-6 mt20">
                  <div class="zone_input" >
                    <div class="zone_input_header">
                      <span class="zone_input_name">{{ $t("Assessment name")}}*</span>
                    </div>
                    <input type="text"  maxLength="30" class="innopearl_input" v-model="internalAssessment.name">
                  </div>
                </div>

                <div class="col-12 col-xl-6 mt20">
                  <div class="zone_input">
                    <div class="zone_input_header">
                      <span class="zone_input_name">{{$t("Assessment deadline")}}*</span>
                    </div>
                    <input type="date"  class="innopearl_input" :min="tomorrowDate" v-model="deadlineDateFormated">
                  </div>

                </div>


                        </div>
              </div>
            </DIV>
            <div class="row mt50">
              <div class="col-12 col-lg-8">

                <div class="row">
                    <div class="zone_input">
                          <div class="zone_input_header flexcentergapbetween">
                              <span class="zone_input_name">{{ $t("Description")}}<br/>
                              <small>Please provide brief project background for the judges</small></span>

                              <button v-if="internalAssessment.type == 'project' && internalAssessment.project" class="prev_step_btn fillDescriptionfromProjectBrief" type="button" @click="fillDescriptionfromProjectBrief" name="button">
                                {{ $t("Fill from project brief")}}
                              </button>
                          </div>
                          <div class="">
                            <QuillEditor ref="linkplusContentEditor"  theme="snow" v-model="internalAssessment.description" :content="internalAssessment.description" contentType="delta" :toolbar="toolbarOptions" />

                          </div>
                    </div>

          </div>
          </div>


             </div>
                        </div>

          </div>
        </div>

        <div class="step-2 criteria-selection" v-if="step == 2">


          <span class="zone_input_name">{{ $t("Please select criteria to be used by judges for the assessment (5 to 12 recommended)")}}</span>
          <div class="addNewZone mt50">
            <button class="prev_step_btn" type="button" @click="dialog = true" name="button">
              <v-img :src="require('@/assets/plusCriteria.svg')" alt=""></v-img>
              {{ $t("Add new criteria")}}
            </button>

          </div>
            <div class="selectedZone">
            <span class="titleSelectedZone">{{ $t("Selected criteria")}}*</span>
            <div class="listOfSelectedCriteria">
              <div class="oneCriteriaSelected" v-for="(criteria,c) in internalAssessment.criterias" :key="c">
                <v-img :src="require('@/assets/infoCriteriaBlanc.svg')" alt=""  @click="toggleDetailsSelected(c)"></v-img>
                <span class="criteriaName">{{criteria.name}} </span>
                  <button class="rm" @click="removeCriteria(criteria)" v-if="internalAssessment.status == 'draft'">
                    <v-img :src="require('@/assets/crossCriteriaBlanc.svg')" alt=""></v-img>
                  </button>
                  <CriteriaDetails v-click-outside="hideDetails" @pleaseEdit="pleaseEdit($event)" @pleaseDeleted="pleaseDeleted($event)" :criteria="criteria" :criteriaGroups="criteriaGroups" v-if="showDetailsIndexInSelected === c"/>


              </div>
              <div class="" v-if="internalAssessment.criterias.length == 0">
                {{$t('No criteria have been selected yet')}}
              </div>
            </div>
          </div>
          <div class="favoriteZone">
              <div class="selectAllArea oneGroupHead oneGroupHeadd" >
                <span class="titleSelectedZone">{{ $t("Favorite criteria")}}</span>

                  <label for="selectAllFav" class="selectIt groupSelectorAllValuesBtnLabel" @click="selectAllFav()"  v-if="internalAssessment.status == 'draft'">
                    <input class="checkbox__input" type="checkbox" value="true" id="selectAllFav" >
                    <span>{{ $t("Select all")}}</span>
                  </label>

              </div>
              <div class="listOfSelectedCriteria">
                <div class="oneFavoriteCriteria" v-for='(criteria, c) in favoriteCriteriaNotInAssessment' :key="c">
                    <button class="unfav" @click="unfavCriteria(criteria)">
                      <v-img :src="require('@/assets/fav.svg')" alt=""></v-img>
                    </button>
                    <v-img :src="require('@/assets/infoCriteriaBleu.svg')" alt=""   @click="toggleDetailsFav(c,g)"></v-img>

                    <span class="criteriaName" @click="selectCriteria(criteria);"  >{{criteria.name}}</span>
                    <button class="selectCriteria">
                      <v-img :src="require('@/assets/addCriteriaBleu.svg')" alt=""  @click="selectCriteria(criteria);"  v-if="internalAssessment.status == 'draft'"></v-img>

                    </button>
                    <CriteriaDetails v-click-outside="hideDetails" @pleaseEdit="pleaseEdit($event)" @pleaseDeleted="pleaseDeleted($event)"  :criteria="criteria" :criteriaGroups="criteriaGroups" v-if="showDetailsIndexInFav === c"/>


                </div>
                <div class="" v-if="favoriteCriteriaNotInAssessment.length == 0">
                  {{$t('All favorite criteria have been added')}}
                </div>
              </div>
          </div>
          <div class="lineDivider">

          </div>
          <div class="allCriteriaZone">
            <span class="titleSelectedZone">{{ $t("Select existing criteria")}}</span>
            <div class="searchbox">

              <div>

  <div class="searchboxInner">
    <input type="text" name="" id="criteriaSearch" @focus="showList = true"
    @blur="onBlur"
     v-model="criteriaSearch">


  <v-card v-if="showList" class="result-list" @mousedown.prevent>
    <v-card-title class="headline">List of existing criteria</v-card-title>


    <div v-for="(group, index) in filterList" :key="index" class="group-item">
      <div class="group-header">
        <span class="group-title">{{ group.name }}</span>
        <!-- <span class="group-count">{{ group.criteriaList.length }}/{{ group.total }}</span> -->
      </div>
      <div v-for="(item, i) in group.criteriaList" :key="i" class="">

        <div class="item" v-if="!isItemInCriterias(item)">
          <button icon @click="selectCriteria(item)"  v-if="internalAssessment.status == 'draft'">
            <v-img :src="require('@/assets/selectCriteria.svg')" alt=""></v-img>

          </button>
          <span class="pointerCursor" @click="selectCriteria(item)" >{{ item.name }}</span>
        </div>
        <div class="item disabledCriteriaSelection" v-else>
        <button icon >  <v-img :src="require('@/assets/selectCriteria.svg')" alt=""></v-img></button>
          <span class="pointerCursor" @click="selectCriteria(item)" >{{ item.name }}</span>

        </div>

      </div>
    </div>
  </v-card>
    </div>
</div>
            </div>
            <div class="listOfSelectedCriteriaWrapper">
                <span class="titleSelectedZone">{{ $t("Existing groups")}}</span>
                <div class="groupsList">
                  <div class="oneGroup" v-for='(group,g) in criteriaGroups' :key="g">
                  <div class="oneGroupHead groupHeadd">
                    <img class="pointerCursor" :src="require('@/assets/open.svg')" @click="group.visible = true" alt="" v-if="!group.visible">
                    <img class="pointerCursor" :src="require('@/assets/close.svg')" @click="group.visible = false" alt="" v-if="group.visible">
                    <span class="groupTitle pointerCursor"  @click="group.visible = !group.visible">{{group.name}}</span>
                    <img class="pointerCursor" v-if="!group.isGlobal" :src="require('@/assets/editCriteria.svg')" @click="editCriteriaToggle(group)">
                    <div class="" v-if="groupCriteriaNotInSelection(group).length > 0 " v-show="group.visible">
                        <label for="selectAllFav" class="selectIt groupSelectorAllValuesBtnLabel" @click="selectAllGroup(group)"  v-if="internalAssessment.status == 'draft'">
                          <input class="checkbox__input" type="checkbox" value="true" id="selectAllFav" >
                          <span>Select all</span>
                        </label>

                    </div>
                  </div>

                  <div class="listOfAvailableCriteria" v-if="group.visible">
                    <div class="oneClassicCriteria" v-for='(criteria, c) in groupCriteriaNotInSelection(group)' :key="c">
                        <button class="unfav" @click="favCriteria(criteria)">
                          <v-img :src="require('@/assets/favGris.svg')" alt=""></v-img>
                        </button>
                        <v-img :src="require('@/assets/infoCriteriaGris.svg')" alt=""  @click="toggleDetailsAvailable(c,g)"></v-img>

                        <span class="criteriaName" @click="selectCriteria(criteria);" >{{criteria.name}}</span>
                        <button class="selectCriteria" @click="selectCriteria(criteria);"  v-if="internalAssessment.status == 'draft'">
                          <v-img :src="require('@/assets/addCriteriaGris.svg')" alt=""></v-img>

                        </button>
                        <CriteriaDetails v-click-outside="hideDetails" @pleaseEdit="pleaseEdit($event)" @pleaseDeleted="pleaseDeleted($event)"  :criteria="criteria" :criteriaGroups="criteriaGroups"  v-if="showDetailsIndexInAvailable === c && showDetailsGroupIndexInAvailable  == g"/>



                    </div>
                    <div class="" v-if="groupCriteriaNotInSelection(group).length == 0">
                      {{$t('No more criterias to display')}}
                    </div>
                </div>
                      </div>
                </div>


                    </div>

        </div>

  </div>



          <div class="step-3 feedBack" v-if="step == 3">
            <span class="zone_input_name">{{ $t("Request free text feedback from judges")}}</span>


            <div class="disableFeedBack mt50">
              <label for="disableFeedBackCheckbox" class="selectIt forceWidth300" >
                <input class="customizeCheckbox" type="checkbox" v-model="internalAssessment.disableFeedback" :disabled="(internalAssessment.status == 'completed' || internalAssessment.status == 'closed')" id="disableFeedBackCheckbox" >
                <span class="custom-checkbox"><img :src="require('@/assets/checkInnoB.svg')" /></span>
                <span>{{ $t("Disable feedback")}}</span>
              </label>
            </div>
            <div class="feedBackContent" v-if="internalAssessment.disableFeedback == false">
              <div class="row ">
                <div class="col-12 col-xl-6 oneFeedbackContent">
                  <div class="zone_input" >
                    <div class="zone_input_header">
                      <span class="zone_input_name">{{ $t("Feedback area 1")}}</span>
                    </div>
                    <input type="text"  :placeholder='$t("ex. Strengths & Advantages")'  :disabled="(internalAssessment.status == 'completed' || internalAssessment.status == 'closed')" class="innopearl_input" v-model="internalAssessment.feedback_1">
                  </div>
                </div>
                <div class="col-12 col-xl-6 oneFeedbackContent">
                  <div class="zone_input" >
                    <div class="zone_input_header">
                      <span class="zone_input_name">{{ $t("Feedback area 2")}}</span>
                    </div>
                    <input type="text"  :placeholder='$t("Key improvement areas")'  :disabled="(internalAssessment.status == 'completed' || internalAssessment.status == 'closed')" class="innopearl_input" v-model="internalAssessment.feedback_2">
                  </div>
                </div>

                <div class="col-12 col-xl-6 oneFeedbackContent">
                  <div class="zone_input" >
                    <div class="zone_input_header">
                      <span class="zone_input_name">{{ $t("Feedback area 3")}}</span>
                    </div>
                    <input type="text"  :placeholder='$t("Potential  use cases")'  :disabled="(internalAssessment.status == 'completed' || internalAssessment.status == 'closed')" class="innopearl_input" v-model="internalAssessment.feedback_3">
                  </div>
                </div>

              </div>
            </div>

          </div>

              <div class="step-4 startupSelection" v-if="step == 4">

                <div class="sidePannel" v-if="showSidePanelBasic == true">

                  <div class="filters">


                    <div class="oneFilter" v-for="(filtre,f) in basicFilters" :key="f">
                      <span class="filtreName clickable" @click="filtre.toggled_sidebar = !filtre.toggled_sidebar">
                        {{filtre.display_name}}<span v-if="filtre.key =='revenue' "> (millions)</span>
                        <sup class="nb_item" v-if="filtre.values.length > 0">{{filtre.values.length}}</sup>
                        <sup class="nb_item" v-else-if="filtre.values.min > 0 || filtre.values.max > 0">1</sup>
                        <sup class="nb_item" v-else-if="filtre.values.from || filtre.values.to">1</sup>
                        <img :src="require('@/assets/triangle.svg')" class="triangle" :class='(filtre.toggled_sidebar == true) ? "open" : "not-open"' alt="">
                      </span>
                      <div v-if="filtre.toggled_sidebar == true">

                      <div class="" v-if="filtre.key =='submitDate' ">
                        <div class="moneyEntryLine">
                          <span class="moneyEntryName">From </span><input class="moneyEntryInput input_filtre" type="date" placeholder="DD/MM/YYYY" v-model="filtre.values.from"/>
                        </div>
                        <div class="moneyEntryLine">
                          <span class="moneyEntryName">To </span> <input class="moneyEntryInput input_filtre" type="date" placeholder="DD/MM/YYYY" v-model="filtre.values.to"/>
                        </div>
                      </div>
                      <div class="" v-else-if="filtre.key =='revenue' ">
                          <div class="moneyEntryLine">
                            <span class="moneyEntryName">From </span><input class="moneyEntryInput input_filtre" type="number" v-model="filtre.values.min"/>
                          </div>
                          <div class="moneyEntryLine">
                            <span class="moneyEntryName">To </span> <input class="moneyEntryInput input_filtre" type="number" v-model="filtre.values.max"/>
                          </div>

                          <!-- <div class="moneyEntryLine">
                            <span class="moneyEntryName">Currency </span>
                            <select class="moneyEntryInput input_filtre" name=""  v-model="filtre.values.devise">
                              <option value="EUR">EUR</option>
                              <option value="USD">USD</option>
                              <option value="CHF">CHF</option>
                            </select>
                        </div> -->


                      </div>
                      <div class="" v-else-if="filtre.key =='linkplus' ">
                      <input type="text" class="input_filtre" name="" placeholder="Search" v-model="filtre.filtre">

                      <div class="value_possible">
                        <label class="checkbox"  v-for="(val,v) in filtre.values_list" :key="v">
                          <div class="checkboxItem"  v-if="val.name.toUpperCase().includes(filtre.filtre.toUpperCase())">


                            <input class="checkbox__input" type="checkbox" v-model="filtre.values" :value="val._id.$oid"/>
                            <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                              <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                              <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                            </svg>
                            <span class="checkbox__label">{{val.name}}</span>
                                  </div>
                          </label>

                      </div>
                    </div>
                      <div class="" v-else>
                      <input type="text" class="input_filtre" name="" placeholder="Search" v-model="filtre.filtre">

                      <div class="value_possible">
                        <label class="checkbox"  v-for="(val,v) in filtre.values_list" :key="v">
                          <div class="checkboxItem"  v-if="val.value.toUpperCase().includes(filtre.filtre.toUpperCase())">


                            <input class="checkbox__input" type="checkbox" v-model="filtre.values" :value="val.value"/>
                            <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                              <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                              <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                            </svg>
                            <span class="checkbox__label">{{val.name}}</span>
                                  </div>
                          </label>

                      </div>
                    </div>
                    </div>
                    </div>
                  </div>
                  <div class="footerPannel">
                      <button type="button" name="button" class="btn_invert" @click="showSidePanelBasic = false">Close</button>
                      <button type="button" @click="reset_bfilter()" class="btn_invert" name="button">Reset filters</button>

                      <button type="button" @click="apply_filter()" class="btn" name="button">Apply filters</button>
                  </div>

                </div>

                <div class="selectedStartups"  v-if="internalAssessment.startups">
                  <div class="row text-center">
                    <span class="titleText">{{ $t('Selected innovators')}}</span>
                  </div>
                  <div class="row actionOnStartups" v-if="internalAssessment.startups.length > 0">
                    <div class="zoneBtn" v-if="internalAssessment.startups.length > 0">
                      <button type="button" class="rmbtn" :class="(are_selected_assessed.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="removeStartupsFromAssessment" :disabled="are_selected_assessed.length == 0">{{ $t("Remove")}}</button>
                    </div>
                  </div>
                  <div class="row listOfSelectedStartups">
                    <div class="col-12">
                        <span v-if="internalAssessment.startups.length <= 1"> {{internalAssessment.startups.length}} innovator</span>
                        <span v-else>{{internalAssessment.startups.length}} innovators</span>
                    </div>
                    <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(candidate, c) in internalAssessment.startups" :key="c">
                      <div class="candidate_card whitehead selectCandidateCard" :class="[(are_selected_assessed.includes(candidate)) ? 'isChecked' : 'notChecked' ]">
                        <div class="candidate_card_head">
                          <span class="name">{{candidate.name}}</span>
                          <div class="goRight">
                            <div class="selectIt">
                              <input class="checkbox__input" name="are_selected_assessed"  id="are_selected_assessed" type="checkbox" v-model="are_selected_assessed" :value="candidate"/>
                              <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                                <rect class="fond" width="21" height="21" x=".5" y=".5" fill="none" stroke="#4c81c0" rx="3" />
                                <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="2" d="M4 10l5 5 9-9" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div class="candidate_info_content">
                          <span class="titreProperty">Value proposition</span>
                          <span class="valueProperty" v-if="candidate.value_proposition">{{candidate.value_proposition}}</span>
                          <span class="valueProperty" v-else>No data</span>

                        </div>
                        <div class="footer_link_cc">

                          <router-link :to="'/startup/'+candidate._id.$oid+'?sf='+sf" target="_blank" v-if="candidate._id" >
                            {{ $t("More details")}}

                          </router-link>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
                <div class="row availableLists" v-if="project_lists.length > 0">

                  <div class="row text-center">
                    <span class="titleText">{{ $t('Available lists')}}</span>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-6 col-lg-4 col-xl-3 candidateList" v-for="(pool, c) in project_lists" :key="c">
                      <div class="candidate_card"  >
                        <div :class="[ pool.byInnopearl ? 'candidate_card_head innopearl' : 'candidate_card_head']">
                          <span class="name" v-if="pool.isLongList">Long list</span>
                          <span class="name" v-else>
                            <span v-if="pool.name">{{pool.name}}</span>
                            <span v-else>Pool without name</span>
                          </span>
                        </div>
                        <div class="candidate_info_content breakFlexCol">
                          <span v-if="pool.candidates.length > 1"> {{pool.candidates.length}} candidates</span>
                          <span v-else>{{pool.candidates.length}} candidate</span>
                        </div>
                        <div class="footer">

                          <button  class="detail" v-if="!pool.showIT" @click="scrollToPool(pool)">
                          SHOW LIST
                        </button>
                        <button  class="detail" v-else @click="pool.showIT = false">
                        HIDE LIST
                      </button>
                        </div>
                      </div>

                    </div>
                  </div>


                  <div class="row mt50" v-for="(pool, c) in shownList" :key="c">
                    <div class="row text-center" :ref="pool._id.$oid">
                      <span class="titleText" v-if="pool.isLongList">Long list</span>
                      <span class="titleText" v-else>
                        <span v-if="pool.name">{{pool.name}}</span>
                        <span v-else>Pool without name</span>
                      </span>

                    </div>
                    <div class="row actionOnStartups">
                      <div class="zoneBtn">
                        <button type="button" class="action_btn" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="addStartupsToAssessment" :disabled="are_selected.length == 0">{{ $t("Add to assessment")}}</button>
                        <button type="button" class="selectAll" @click="selectAllStartupsPool(pool)" v-if='!pool.allSelected' name="button">{{ $t("Select All")}} </button>
                        <button type="button" class="selectAll" @click="unselectAllStartupsPool(pool)" v-if='pool.allSelected' name="button">{{ $t("Unselect All")}} </button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(candidate, c) in pool.candidates" :key="c">
                        <div class="candidate_card" :class="[(are_selected.includes(candidate)) ? 'isChecked' : 'notChecked' ]">
                          <div class="candidate_card_head">
                            <span class="name">{{candidate.name}}</span>
                            <div class="goRight">
                              <div class="selectIt">
                                <input class="checkbox__input" name="are_selected"  id="are_selected" type="checkbox" v-model="are_selected" :value="candidate"/>
                                 <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                                  <rect class="fond" width="21" height="21" x=".5" y=".5" fill="none" stroke="#fff" rx="3" />
                                  <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="2" d="M4 10l5 5 9-9" />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div class="candidate_info_content">
                            <StartupInfoLine v-if="candidate.application_area" name="Application domain" :value="candidate.application_area" :isArray="Array.isArray(candidate.application_area)" />
                            <StartupInfoLine v-else name="Application domain" value="No data" />

                              <StartupInfoLine v-if="candidate.value_proposition" name="Value proposition" :value="candidate.value_proposition"  :isArray="Array.isArray(candidate.value_proposition)"/>
                              <StartupInfoLine v-else name="Value proposition" value="No data" />

                              <StartupInfoLine v-if="candidate.solution" name="Solution" :value="candidate.solution" :isArray="Array.isArray(candidate.solution)" />
                              <StartupInfoLine v-else name="Solution" value="No data" />
                          </div>
                          <div class="footer">

                            <router-link :to="'/startup/'+candidate._id.$oid+'?sf='+sf"  v-if="candidate._id" target="_blank">
                              {{ $t("Details")}}
                              <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                                <g fill="none" stroke="#4c81c0" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10">
                                  <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                                </g>
                            </svg>
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="row text-center mt50">
                    <div class="col-12 putbtn-center">
                      <button class="next-button" v-if="showMoreStartups == false" @click="showMoreStartups = true"> {{$t("Show innovator pool")}} </button>
                      <button class="next-button" v-else @click="showMoreStartups = false"> {{$t("Hide innovator pool")}}  </button>

                    </div>
                  </div>


                </div>


                <div class="row availableStartups" v-if="showMoreStartups">
                  <div class="row text-center">
                    <span class="titleText">{{ $t('Add from innovator pool')}}</span>
                  </div>
                  <div class="filters_startups">
                      <div class="quicksearch">
                            <input type="text" class="input" placeholder="Search by name"  v-model="quicksearch">
                      </div>
                      <div class="tooglerFilter">
                        <div class="toogler" @click="showSidePanelBasic = !showSidePanelBasic">
                            FILTER
                            <small class="nb_item" v-if="basicFilters.filter(obj => ((Array.isArray(obj.values) && obj.values.length > 0) || (obj.values.min > 0 || obj.values.max > 0) || (obj.values.from || obj.values.to))).length  > 0">{{basicFilters.filter(obj => ((Array.isArray(obj.values) && obj.values.length > 0) || (obj.values.min > 0 || obj.values.max > 0) || (obj.values.from || obj.values.to))).length  }}</small>
                            <img :src="require('@/assets/web.png')" class="" alt="">
                        </div>
                      </div>
                  </div>
                  <div class="row actionOnStartups">
                    <div class="zoneBtn">
                      <button type="button" class="action_btn" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="addStartupsToAssessment" :disabled="are_selected.length == 0">{{ $t("Add to assessment ")}}</button>
                      <button type="button" class="selectAll" @click="selectAllStartups" v-if='allSelect == false' name="button">{{ $t("Select All")}} </button>
                      <button type="button" class="selectAll" @click="unselectAllStartups" v-if='allSelect == true' name="button">{{ $t("Unselect All")}} </button>
                    </div>
                  </div>
                  <div class="loaderInnopearl mt50" v-if="loading">
                    <div class="loaderInnopearlInner">
                      <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
                      <span>Loading in progress</span>
                    </div>

                  </div>
                  <div v-else>


                  <div class="listofstartus row" v-if="startups_quicksearch.length > 0">
                    <div class="col-12">
                        <span v-if="startups_quicksearch.length == 1"> {{startups_quicksearch.length}} innovator</span>
                        <span v-else>{{startups_quicksearch.length}} innovators</span>
                    </div>
                    <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(candidate, c) in startups_quicksearch" :key="c">
                      <div class="candidate_card" :class="[(are_selected.includes(candidate)) ? 'isChecked' : 'notChecked' ]">
                        <div class="candidate_card_head">
                          <span class="name">{{candidate.name}}</span>
                          <div class="goRight">
                            <div class="selectIt">
                              <input class="checkbox__input" name="are_selected"  id="are_selected" type="checkbox" v-model="are_selected" :value="candidate"/>
                               <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                                <rect class="fond" width="21" height="21" x=".5" y=".5" fill="none" stroke="#fff" rx="3" />
                                <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="2" d="M4 10l5 5 9-9" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div class="candidate_info_content">
                          <StartupInfoLine v-if="candidate.application_area" name="Application domain" :value="candidate.application_area" :isArray="Array.isArray(candidate.application_area)" />
                          <StartupInfoLine v-else name="Application domain" value="No data" />

                            <StartupInfoLine v-if="candidate.value_proposition" name="Value proposition" :value="candidate.value_proposition"  :isArray="Array.isArray(candidate.value_proposition)"/>
                            <StartupInfoLine v-else name="Value proposition" value="No data" />

                            <StartupInfoLine v-if="candidate.solution" name="Solution" :value="candidate.solution" :isArray="Array.isArray(candidate.solution)" />
                            <StartupInfoLine v-else name="Solution" value="No data" />
                        </div>
                        <div class="footer">

                          <router-link :to="'/startup/'+candidate._id.$oid+'?sf='+sf"  v-if="candidate._id" target="_blank">
                            {{ $t("Details")}}
                            <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                              <g fill="none" stroke="#4c81c0" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10">
                                <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                              </g>
                          </svg>
                          </router-link>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="listofstartus row" v-else>
                    {{ $t("No innovators available. Please adjust the criteria and try again.")}}
                  </div>
                            </div>
                </div>


              </div>

              <div class="step-5 jugesSelection" v-if="step == 5">


                <div class="row mt20">
                  <div class="col-12 col-xl-6 pad25 selectionJugeLeft" style="">
                    <div class="">
                        <!-- <label for="withLicense" class="selectIt" >
                          <input class="" type="checkbox" v-model="internalAssessment.withLicense" value="true" id="withLicense" >
                          <span>{{ $t("Assessment by judges with Partner+ licenses")}}</span>
                        </label> -->

                        <label for="withLicense" class="selectIt" >
                          <input class="customizeCheckbox" type="checkbox" v-model="internalAssessment.withLicense" value="true" id="withLicense" >
                          <span class="custom-checkbox"><img :src="require('@/assets/checkInnoB.svg')" /></span>
                          <span class="boldblue">{{ $t("Includes judges with Partner+ licenses")}}</span>
                        </label>
                    </div>
                    <div class="" v-if="internalAssessment.withLicense == true">
                      <div class=" col-12 mt50">
                        <div class="zone_input_header">
                        <span class="zone_input_name">{{ $t("Selected email addresses")}}</span>
                      </div>
                    </div>
                      <div class="listOfSelectedCriteria mb50" v-if="getJudgesWithLicenses().length > 0">

                        <div class="oneJudgeSelected" v-for="(judge,c) in getJudgesWithLicenses()" :key="c">
                            <span class="criteriaName">{{judge.email}} </span>
                            <button class="rmjudge" @click="removeJudge(judge)">
                              <v-img :src="require('@/assets/removeJudge.svg')" alt=""></v-img>
                            </button>
                        </div>
                      </div>
                      <div class="listOfSelectedCriteria mb50" v-else>
                        {{$t("No judge selected")}}
                      </div>

                      <div class="addNewJudge mt20 mb50">
                        <div class="row">
                            <div class="col-12 zone_input">
                              <div class="zone_input_header">
                                <span class="zone_input_name">{{ $t("Select a judge in the list*")}}</span>
                              </div>
                              <div class="searchbox">

                                <div>

                    <div class="searchboxInner">
                      <input type="text" name="" id="criteriaSearch" @focus="showList = true" @blur="onBlur" v-model="userSearch">


                    <v-card v-if="showList" class="result-list" @mousedown.prevent>
                      <div v-for="(user, index) in getUserNotInAssessment()" :key="index" class="group-item">

                        <div  class="item">
                          <button icon @click="selectJudge(user)">
                            <v-img :src="require('@/assets/selectCriteria.svg')" alt=""></v-img>

                          </button>
                          <span class="pointer" @click="selectJudge(user)"> {{ user.firstname }} {{user.lastname}}</span>

                        </div>
                      </div>
                      <div class="group-item" v-if="getUserNotInAssessment().length == 0">
                      <div class="item">
                        {{$t("No matching")}}
                      </div>
                      </div>
                    </v-card>
                      </div>
                  </div>
                              </div>
                              <div class="inputWithIcon">
                              </div>
                            </div>


                        </div>
                      </div>


                      <div class="iamajudge">

                        <label for="iamajudgeSelector" class="selectIt" >
                          <input class="customizeCheckbox" type="checkbox" v-model="internalAssessment.iamajudge" @change="amijudge" value="true" id="iamajudgeSelector" >
                          <span class="custom-checkbox"><img :src="require('@/assets/checkInnoB.svg')" /></span>

                          <span class="boldblue">{{ $t("I am a judge")}}</span>
                        </label>



                      </div>
                    </div>



                  </div>


                  <div class="col-12 col-xl-6 pad25">
                    <div class="">
                      <label for="guestJudges" class="selectIt" >
                        <input class="customizeCheckbox" type="checkbox" v-model="internalAssessment.guestJudges" @change="emailContentSetter" value="true" id="guestJudges" >
                        <span class="custom-checkbox"><img :src="require('@/assets/checkInnoB.svg')" /></span>
                        <span class="boldblue">{{ $t("Includes judges without Partner+ licenses")}}</span>
                      </label>


                    </div>
                    <div class="" v-if="internalAssessment.guestJudges == true">
                      <div class=" col-12 mt50">
                        <div class="zone_input_header">
                        <span class="zone_input_name">{{ $t("Selected email addresses")}}</span>
                      </div>
                    </div>
                      <div class="listOfSelectedCriteria mb50" v-if="getJudgesWithoutLicenses().length > 0">

                        <div class="oneJudgeSelected" v-for="(judge,c) in getJudgesWithoutLicenses()" :key="c">
                            <span class="criteriaName">{{judge.email}} </span>
                            <button class="rmjudge" @click="removeJudge(judge)">
                              <v-img :src="require('@/assets/removeJudge.svg')" alt=""></v-img>
                            </button>
                        </div>
                      </div>
                      <div class="listOfSelectedCriteria mb50" v-else>
                        {{$t("No judge selected")}}
                      </div>
                      <div class="addNewJudge mt20">
                        <div class="row">
                            <div class="col-12 zone_input">
                              <div class="zone_input_header">
                                <span class="zone_input_name">{{ $t("Enter email address")}}</span>
                              </div>
                              <div class="inputWithIcon">
                                <input v-model="newGuestEmails" type="text" :placeholder="$t('Add one or more emails, separated by a comma')" @keyup.enter="addGuestJudges" class="innopearl_input" />

                                <v-img :src="require('@/assets/plusJudges.svg')" alt="" :disabled="newGuestEmails == ''" @click="addGuestJudges"></v-img>

                              </div>
                            </div>


                        </div>
                      </div>

                      <div class="messageEmail">
                          <div class="col-12 zone_input">
                            <div class="zone_input_header mb10">
                                <span class="zone_input_name">{{ $t("Add a message")}}</span>
                            </div>
                            <QuillEditor ref="emailContentForAssessment" theme="snow" v-model="internalAssessment.emailContent" :content="internalAssessment.emailContent" contentType="delta" :toolbar="toolbarOptionsEmail" />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
      </div>

    </div>


  </div>
  </div>
</template>
<script>
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import StartupInfoLine from '@/components/InfoStartupLine.vue'

//import { Toaster, toast } from 'vue-sonner'
import CreateCriteriaModal from '@/components/modals/createCriteria.vue'
import UpdateCriteriaModal from '@/components/modals/updateCriteriaUser.vue'
import countries from '@/assets/flat_countries_db.json';
import UpdateNameModal from '@/components/modals/projectNameModal.vue'

import CriteriaDetails from '@/components/CriteriaDetail.vue'
 import api from '../tools/api';
 import { toast } from 'vue-sonner'
export default {
  components: {
    QuillEditor,
    CreateCriteriaModal,
    UpdateCriteriaModal,
    UpdateNameModal,
    CriteriaDetails,
    StartupInfoLine
  },
  name: 'InternalAssessmentCreation',
  data() {
    return {
      newGuestEmails:"",
      dialog:false,
      mainLoading: false,
      withLicense:false,
      guestJudges : false,
      showMoreStartups:false,
      pageInfo: {
        mainTitle : "My assessment space ",
        subTitle : this.$t("Define scope"),
      },
      default_content_for_email:"",
      userSearch:"",
      showList:false,
      optionsType: [
        { value: 'new', text: 'New Assessment' },
        { value: 'project', text: 'Project Assessment' }
      ],
      showSidePanelBasic: false,
      showDetailsIndexInSelected:null,
      showDetailsIndexInFav:null,
      showDetailsIndexInAvailable:null,
      criteriaSearch:"",
      projects : [],
      criteriaGroups: [],
      step: 4,
      dict_loaded : false,
      dialogUpdateNameModal:false,
      ask_for_edit : {},
      quicksearch:"",
      userInfo:{},
      myfavcriterias: {criteriaList: []},
      internalAssessment : {
        _id:null,
        type:"",
        name : "",
        project : null,
        deadline : null,
        description : "",
        criterias : [],
        disableFeedback : false,
        feedback_1 : "Strengths & Advantages",
        feedback_2 : "Key improvement areas",
        feedback_3 : "Potential use cases",
        startups : [],
        status : 'draft',
        judges : []
      },
      toupdate:null,
      dialogUpdate:false,
      allSelect: false,
      startups: [],
      are_selected: [],
      project_lists: [],
      are_selected_assessed: [],
      startups_quicksearch: [],
      toolbarOptions : [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent                  // text direction
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        ['clean']                                         // remove formatting button
      ],
      toolbarOptionsEmail : [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent                  // text direction
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        ['clean']                                         // remove formatting button
      ],
      contentHTML:"",
      basicFilters: [
          {
              "key": "application_area",
              "dict": "application_areas",
              "values": [],
              "values_list": [],
              "display_name": "Application domain",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "assets",
              "values": [],
              "dict": "type_of_assets",
              "values_list": [],
              "display_name": "Assets",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "business_model",
              "values": [],
              "values_list": [],
              "display_name": "Business model",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "company_type",
              "dict": "company_type",
              "values": [],
              "values_list": [],
              "display_name": "Company type",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "data_available",
              "dict": "data_available",
              "values": [],
              "values_list": [],
              "display_name": "Data available",
              toggled: false,
              toggled_sidebar: false,
              filtre:""
          },
          {
              "key": "development_stage",
              "values": [],
              "values_list": [],
              "display_name": "Development stage",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "funding_stage",
              "values": [],
              "values_list": [],
              "display_name": "Funding Stage",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "innovation_area",
              "dict": "innovation_areas",
              "values": [],
              "values_list": [],
              "display_name": "Innovation area",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "product_category",
              "values": [],
              "values_list": [],
              "display_name": "Innovation category",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "IP",
              "values": [],
              "dict": "ip",
              "values_list": [],
              "display_name": "IP",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "location",
              "values": [],
              "values_list": countries,
              "display_name": "Location",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "markets",
              "values": [],
              "values_list": [],
              "display_name": "Served markets",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "partnership_objectives",
              "values": [],
              "dict": "partnership_objectives",
              "values_list": [],
              "display_name": "Partnership objectives",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "revenue",
              "display_name": "Revenue",
              "values": {
                  "min": 0,
                  "max": 0,
                  "unit": "M",
                  "devise": "EUR"
              },
              toggled_sidebar: false,
          },
          {
              "key": "skills",
              "values": [],
              "values_list": [],
              "display_name": "Skills",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "sustainability_impact",
              "values": [],
              "dict": "sustainability_impact",
              "values_list": [],
              "display_name": "Sustainability impact",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "submitDate",
              "display_name": "Application date",
              "values": {
                  "from": null,
                  "to": null,
              },
              toggled_sidebar: false,
          }
      ],


}

  },
  methods:{
    isItemInCriterias(item) {
      // Assuming each item has a unique identifier, e.g., item.id
      return this.internalAssessment.criterias.some(
        (criteria) => criteria._id.$oid == item._id.$oid
      );
    },
    handleSaveBeforeRedirect(){
      if(this.$refs.linkplusContentEditor)this.internalAssessment.description = this.$refs.linkplusContentEditor.getHTML();
      if(this.$refs.emailContentForAssessment)this.internalAssessment.emailContent = this.$refs.emailContentForAssessment.getHTML();
        this.mainLoading = true;
      this.internalAssessment.dateFormated = this.deadlineDateFormated;
      api.post(process.env.VUE_APP_API_URL+"/restrict/updateAssessment",
        {
          assessment :this.internalAssessment
        },
        { headers: {'Content-Type': 'application/json',}}
      ).then( () => {
        this.mainLoading = false;
        this.$nextTick(() => {
                // this.step++;


      if(this.$refs.linkplusContentEditor)this.$refs.linkplusContentEditor.setHTML(this.internalAssessment.description );
      if(this.internalAssessment.emailContent){
        if(this.$refs.emailContentForAssessment)this.$refs.emailContentForAssessment.setHTML(this.internalAssessment.emailContent);

      }
      else{
        if(this.$refs.emailContentForAssessment)this.$refs.emailContentForAssessment.setHTML(this.default_content_for_email);
      }
      var routePath =
          "/internalassessment_preview/" +
          this.internalAssessment._id.$oid +
          "?step=" +
          this.step;
        this.$router.push(routePath);
    });
                  // this.step++;


      } ).catch( (e) => {
              this.mainLoading = false;
        console.log("edse",e);
        if(e.message){
          toast.error(e.message)

        }
        else{
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

        }
      });

    },
    editCriteriaToggle(group){
      this.dialogUpdateNameModal = true;
      this.ask_for_edit =group;
    },
    uneditCriteriaToggle(){
      this.dialogUpdateNameModal = false;
      this.ask_for_edit = {};
    },
    setNewGroupName(v){
      if(v){
        this.ask_for_edit.name = v;
        api.post(process.env.VUE_APP_API_URL+"/restrict/updateCriteriaGroup",this.ask_for_edit,
        { headers: {'Content-Type': 'application/json',}}
      ).then( (r) => {
        console.log(r);
        this.dialogUpdateNameModal = false;
        this.ask_for_edit = {};
        toast.success("Group successfully renamed")
        }).catch( () => {
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        this.uneditCriteriaToggle();
      }
    },
    maybeSetName(){
        const foundItem = this.projects.find(item => item._id.$oid == this.internalAssessment.project.$oid);
        this.internalAssessment.name = foundItem.name;
    },
    scrollToPool(pool){
      pool.showIT = true;
        this.$nextTick(() => {
            var targetRef = this.$refs[pool._id.$oid];
            console.log(targetRef);
            if (targetRef) {
                // Scroll to the ref
                targetRef[0].scrollIntoView({ behavior: 'smooth' });
            }
          });

  },
    emailContentSetter(){
      if(this.internalAssessment.emailContent){
        if(this.$refs.emailContentForAssessment)this.$refs.emailContentForAssessment.setHTML(this.internalAssessment.emailContent);
      }
      else{
        if(this.$refs.emailContentForAssessment)this.$refs.emailContentForAssessment.setHTML(this.default_content_for_email);
      }
    },
    saveIt(){
      this.updateAssessment();
    },
    pleaseEdit(c){
        this.toupdate = c;
        this.dialogUpdate = true;
    },
    sendInvit(){
      //on post l'assessment et le message
      // on met le message dans l'assessment comme ca il sera reafficher si on veut rajouter des juges plutard.
      //dans l'envoi on prend la liste des juges qui n'ont pas de licence (licenced == false)et a qui on n'a pas déjà envoyer le mail (mailSend == false)
      //apres envoi du mail on met mailSend a true pour le juge (comme ca il ne recoit pas de nouvelle notif si on renvoi une salve d'invit)
      // VERIFICATION NEEDS TO BE DONE BEFORE
      var error = false;
        //first check assessment type
      if(this.internalAssessment.type){
            if(this.internalAssessment.type == 'new'){
              if(this.internalAssessment.name.trim() == ""){
                toast.error(this.$t("Please enter an assessment name to proceed"));
                  error = true;
              }
            }
            if(this.internalAssessment.type == 'project'){
              if(!this.internalAssessment.project){
                toast.error(this.$t("PLease select your project"));
                error = true;
              }
            }
            if(!this.deadlineDateFormated){
              toast.error(this.$t("PLease select your deadline"));
              error = true;
            }
      }
      else{
        toast.error(this.$t("Please choose between new assessment or project assessment"));
        error = true;
      }


        //first check assessment type
        if(this.internalAssessment.criterias.length < 3){
          error = true;
          toast.error(this.$t("Please select at least 3 criterias to proceed"));
        }



        if(this.internalAssessment.disableFeedback == false){
          if(this.internalAssessment.feedback_1 == '' && this.internalAssessment.feedback_2 == '' && this.internalAssessment.feedback_3 == ''){
            toast.error(this.$t("Please complete the feedback domains or disable this requirement."));
            error = true;
          }
        }

        if(this.internalAssessment.startups.length == 0){
          error = true;
          toast.error(this.$t("Please select innovators to assess"));
        }

        if(this.internalAssessment.judges.length == 0){
          error = true;
          toast.error(this.$t("Please choose at least one judge to proceed"));
        }
        if(this.internalAssessment.guestJudges == true){
          if(!this.$refs.emailContentForAssessment){
            error =true;
            toast.error(this.$t("Please provide a message"));
          }

        }


      if(!error){
        //if no judge
        api.post(process.env.VUE_APP_API_URL+"/restrict/sendInvit",
          {
            assessment :this.internalAssessment,
            message: (this.$refs.emailContentForAssessment) ? this.$refs.emailContentForAssessment.getHTML() : ""
          },
          { headers: {'Content-Type': 'application/json',}}
        ).then( (r) => {
            console.log("dfqsd",r.data);
            this.internalAssessment.status = "progress";
            toast.success(this.$t("Invitations to judges are sent successfully. You can view the Assessment results after the deadline."));
            this.step = 6;

          }).catch( (e) => {
            console.log(e);
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
      }



    },
    amijudge(){

      if(this.internalAssessment.iamajudge == true){
        api.post(process.env.VUE_APP_API_URL+"/restrict/addMyselfToAssessment",
          {
            assessment :this.internalAssessment,
            judge: this.userInfo
          },
          { headers: {'Content-Type': 'application/json',}}
        ).then( (r) => {
            console.log("dfqsd",r.data);
            this.internalAssessment = r.data

          }).catch( (e) => {
            console.log(e);
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
      }
      else{
        this.removeJudge(this.userInfo)
      }
    },
    selectJudge(user){
      api.post(process.env.VUE_APP_API_URL+"/restrict/addJudgesWithLicenseToAssessment",
        {
          assessment :this.internalAssessment,
          judge: user
        },
        { headers: {'Content-Type': 'application/json',}}
      ).then( (r) => {
          console.log("dfqsd",r.data);
          this.internalAssessment = r.data

        }).catch( (e) => {
          console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
    },
    addGuestJudges(){
      console.log(this.newGuestEmails);
    //  var emailArray = this.newGuestEmails.split(',').map(email => email.trim());
      const emailRegex = /[\w._%+-]+@[\w.-]+\.[a-zA-Z]{2,}/g;
      var emailArray = this.newGuestEmails.match(emailRegex) || [];
      if(emailArray.length == 0){
        toast.error(this.$t("Please enter a valid email address, using a comma for multiple addresses."));
        error = true;
        return;
      }
      var error = false;
      for (let email of emailArray) {
       if (!this.validateEmail(email)) {
         // If an email is invalid, show an error toast and return early
         toast.error(this.$t("Please enter a valid email address, using a comma for multiple addresses."));
         error = true;
         return;
       }
     }
     if(!error){
       api.post(process.env.VUE_APP_API_URL+"/restrict/addGuestJudgesToAssessment",
         {
           assessment :this.internalAssessment,
           emails: emailArray
         },
         { headers: {'Content-Type': 'application/json',}}
       ).then( (r) => {
           console.log("dfqsd",r.data);
           this.internalAssessment = r.data
           this.newGuestEmails = "";
         }).catch( (e) => {
           console.log(e);
           toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
         });
     }
    },
    validateEmail(email){
      var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(String(email).toLowerCase());
    },
    removeJudge(judge){
      api.post(process.env.VUE_APP_API_URL+"/restrict/removeJudgeFromAssessment",{
                judge : judge,
                assessment : this.internalAssessment,
              },
              {
                headers: {
                    'Content-Type': 'application/json',
              }
            }).then( () => {
              this.internalAssessment.judges = this.internalAssessment.judges.filter(item => item.email !== judge.email);

      }).catch( (e) => console.log(e));
    },

    getUserNotInAssessment(){
      var searchTerm = this.userSearch.toLowerCase();


      var users_in = new Set(this.internalAssessment.judges.filter(judge => judge.user && judge.user.$oid).map(c => c.user.$oid));
      var toret = [];
      if(this.userInfo.account_managed){
         toret = this.userInfo.account_managed.filter( (user) =>{
          var full_name1 = user.lastname+" "+user.firstname;
          var full_name2 = user.firstname+" "+user.lastname;
          if(!users_in.has(user._id.$oid) && (full_name1.toLowerCase().includes(searchTerm) || full_name2.toLowerCase().includes(searchTerm) ) ){
              return true
          }

        });
      }
      if(this.userInfo.other_accounts){
         toret = this.userInfo.other_accounts.filter( (user) =>{
          var full_name1 = user.lastname+" "+user.firstname;
          var full_name2 = user.firstname+" "+user.lastname;
          if(!users_in.has(user._id.$oid) && (full_name1.toLowerCase().includes(searchTerm) || full_name2.toLowerCase().includes(searchTerm) ) ){
              return true
          }

        });
      }


      return toret;

    },
    getJudgesWithLicenses(){
      var toret = this.internalAssessment.judges.filter(judge =>
           judge.licenced == true
      );
      console.log("toret",toret);
      return toret;
    },
    getJudgesWithoutLicenses(){
      var toret = this.internalAssessment.judges.filter(judge =>
           judge.licenced == false
      );
      console.log("toret",toret);
      return toret;
    },
    goToStep(step){
    //  if(this.internalAssessment.createdFor){

      if(this.step == 1){
        if(this.stepIsDone(1)){
                        this.updateAssessment();
            this.step = step;
          }
      }

      else if(this.stepIsDone(this.step)){
                    this.updateAssessment();
        this.step = step;
        if(this.step  == 1){
          this.$nextTick(() => {
            if(this.$refs.linkplusContentEditor)
              this.$refs.linkplusContentEditor.setHTML(this.internalAssessment.description );
          });
        }
      }
      else{
        if(step < this.step){
          this.step = step;
          if(this.step  == 1){
            this.$nextTick(() => {
              if(this.$refs.linkplusContentEditor)
                this.$refs.linkplusContentEditor.setHTML(this.internalAssessment.description );
            });
          }
        }
      }
    //  }

    },
    stepIsDone(step){
      if(step == 1){
        return (this.internalAssessment._id );
      }
      else if(step == 2){
        return (this.internalAssessment.criterias.length > 0);
      }
      else if(step == 3){
        return true;
      }
      else if(step == 4){
        return (this.internalAssessment.startups.length > 0);
      }
      else if(step == 5){
        return (this.internalAssessment.judges.length > 0);
      }
    },
    reset_bfilter(){
      this.basicFilters.forEach((item) => {
        if(item.key != "revenue" && item.key != "submitDate"){
          item.values = [];
        }
        else{
          if(item.key == "revenue"){
            item.values = {
              "min": 0,
              "max" : 0,
              "unit": "M",
              "devise": "EUR"
            };
          }
          if(item.key == "submitDate"){
            item.values = {
              "from": null,
              "to" : null,
            };
          }

        }

      });
      this.apply_filter();
      this.showSidePanelBasic = true;
    },
    createAssessment(){
      if(this.internalAssessment._id){
          this.updateAssessment();

      }
      else{
        this.internalAssessment.description = this.$refs.linkplusContentEditor.getHTML();
        this.internalAssessment.dateFormated = this.deadlineDateFormated;
          //Si l'assessment en cours n'a pas d'id c'est que l'on est sur un processus de creation.
        api.post(process.env.VUE_APP_API_URL+"/restrict/createAssessment",
          {
            assessment :this.internalAssessment
          },
          { headers: {'Content-Type': 'application/json',}}
        ).then( (r) => {
            console.log("dfqsd",r.data);
            this.internalAssessment = r.data
            this.$nextTick(() => {
              if(this.$refs.linkplusContentEditor)this.$refs.linkplusContentEditor.setHTML(this.internalAssessment.description);
              // this.step++;
            });
            if(this.internalAssessment.deadline){

              this.deadlineDateFormated = this.internalAssessment.deadline.date.split(' ')[0];
            }

          }).catch( (e) => {
            console.log(e);
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
      }

    },
    updateAssessment(){

        //si l'assessment a déjà un _id, c'est qu'il existe en db, on doit le maj.
        // 2 cas ce présent a la step 1 : il y a déja une selection de startup || il n'y a pas de selection
        if(this.$refs.linkplusContentEditor)this.internalAssessment.description = this.$refs.linkplusContentEditor.getHTML();
        if(this.$refs.emailContentForAssessment)this.internalAssessment.emailContent = this.$refs.emailContentForAssessment.getHTML();
          this.mainLoading = true;
        this.internalAssessment.dateFormated = this.deadlineDateFormated;
        api.post(process.env.VUE_APP_API_URL+"/restrict/updateAssessment",
          {
            assessment :this.internalAssessment
          },
          { headers: {'Content-Type': 'application/json',}}
        ).then( () => {
            this.mainLoading = false;
            this.$nextTick(() => {
                    // this.step++;
          toast.success(this.$t("YOUR DATA IS SAVED"));

          if(this.$refs.linkplusContentEditor)this.$refs.linkplusContentEditor.setHTML(this.internalAssessment.description );
          if(this.internalAssessment.emailContent){
            if(this.$refs.emailContentForAssessment)this.$refs.emailContentForAssessment.setHTML(this.internalAssessment.emailContent);

          }
          else{
            if(this.$refs.emailContentForAssessment)this.$refs.emailContentForAssessment.setHTML(this.default_content_for_email);
          }
        });
        } ).catch( (e) => {
                this.mainLoading = false;
          console.log("edse",e);
          if(e.message){
            toast.error(e.message)

          }
          else{
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

          }
        });

    },
    fillDescriptionfromProjectBrief(){
        if(this.internalAssessment.project){
          api.get(process.env.VUE_APP_API_URL+"/restrict/getdescriptionfrombrief/"+this.internalAssessment.project.$oid).then( (r) => {
            console.log("desc : ",r.data);
            this.$refs.linkplusContentEditor.setHTML(r.data);
          }).catch( (e) => console.log(e));
        }
    },
    getGroupNameById(id) {
      console.log("search id:",id);
      console.log(this.criteriaGroups);
      var group = this.criteriaGroups.find(g => g._id.$oid == id.$oid);
      console.log("dinf ",group);
      return group ? group.name : null; // Return the groupname or null if not found
    },
    toggleDetailsSelected(index) {

      if (this.showDetailsIndexInSelected === index) {
        this.showDetailsIndexInSelected = null; // Hide if already visible
      } else {
        this.showDetailsIndexInSelected = index; // Show the clicked index
        this.showDetailsIndexInFav = null; // Hide if already visible
        this.showDetailsIndexInAvailable = null; // Hide if already visible
        this.showDetailsGroupIndexInAvailable = null;
      }
    },
    newCriteriaCreated(crit){
      if(crit){
        // api.get(process.env.VUE_APP_API_URL+"/restrict/mycriteriabygroup").then( (r) => {
        //   this.criteriaGroups = r.data;
        //   console.log("criterias : ",r.data);
        //   console.log(r);
        // }).catch( (e) => console.log(e));
        api.get(process.env.VUE_APP_API_URL+"/restrict/mycriteriabygroup").then( (r) => {
          this.criteriaGroups = r.data;
          console.log("criterias : ",r.data);
          console.log(r);
        }).catch( (e) => console.log(e));
        if(crit.includeInAssessment)this.selectCriteria(crit.insertedCriteria);
      }
      this.dialog = false;
      this.dialogUpdate = false;
    },
    toggleDetailsFav(index) {
      if (this.showDetailsIndexInFav === index) {
        this.showDetailsIndexInFav = null; // Hide if already visible
      } else {
        this.showDetailsIndexInFav = index; // Show the clicked index
          this.showDetailsIndexInAvailable = null; // Hide if already visible
          this.showDetailsIndexInSelected = null;
      }
    },
    toggleDetailsAvailable(index,group) {
      if (this.showDetailsIndexInAvailable === index && this.showDetailsGroupIndexInAvailable == group) {
        this.showDetailsIndexInAvailable = null; // Hide if already visible
        this.showDetailsGroupIndexInAvailable = null;
      } else {
        this.showDetailsIndexInAvailable = index; // Show the clicked index
        this.showDetailsGroupIndexInAvailable = group;
      this.showDetailsIndexInFav = null; // Hide if already visible
      this.showDetailsIndexInSelected = null;
      }
    },
    hideDetails(){
      this.showDetailsIndexInFav = null; // Hide if already visible
      this.showDetailsIndexInSelected = null;
      this.showDetailsIndexInAvailable = null; // Hide if already visible

    },
    next(){

      var error = false;
      if(this.step == 1){

        //first check assessment type
        if(this.internalAssessment.type){
            if(this.internalAssessment.type == 'new'){
              if(this.internalAssessment.name.trim() == ""){
                toast.error(this.$t("Please enter an assessment name to proceed"));
                  error = true;
              }
            }
            if(this.internalAssessment.type == 'project'){
              if(!this.internalAssessment.project){
                toast.error(this.$t("PLease select your project"));
                error = true;
              }
            }
            else{
              this.internalAssessment.project = null;
            }
            if(!this.deadlineDateFormated){
              toast.error(this.$t("PLease select your deadline"));
              error = true;
            }
        }
        else{
          toast.error(this.$t("Please choose between new assessment or project assessment"));
          error = true;
        }

        if(!error){
          if(this.internalAssessment._id){

            this.updateAssessment();
          }
          else {

            this.createAssessment();
          }
        }
      }
      else if(this.step == 2){
        //first check assessment type
        if(this.internalAssessment.criterias.length < 3){
          error = true;
          toast.error(this.$t("Please select at least 3 criterias to proceed"));
        }
        if(this.internalAssessment.criterias.length > 12){
          //error = true;
        //  toast.warning("12 CRITERIAS OR LESS IS RECOMMANDED FOR OPTIMAL ASSESSMENT, BUT YOU CAN STEEL PROCEED");
        toast(this.$t('12 criterias or less is recommanded for optimal assessement, but you can still proceed'), {

          style: {
             background: '#d0c192'
           },
        })
        }
        console.log("2222222222 sdfiosudfp^q dfshosu dfpoiqsuf ddpoqs");


      }
      else if(this.step == 3){
          console.log(this.internalAssessment.disableFeedback);
          if(this.internalAssessment.disableFeedback == true){
            error = true;
            toast(this.$t('Judges will only be asked to provide rating values'), {
              style: {
                 background: '#d0c192'
               },
            });
            this.updateAssessment()
            this.step++
          }
        else{
          if(this.internalAssessment.feedback_1 == '' && this.internalAssessment.feedback_2 == '' && this.internalAssessment.feedback_3 == ''){
            toast.error(this.$t("Please complete the feedback domains or disable this requirement."));
            error = true;
          }
          else{
            this.updateAssessment();
          }
        }

      }
      else if(this.step == 4){
        if(this.internalAssessment.startups.length == 0){
          error = true;
          toast.error(this.$t("Please select innovators to assess"));
        }
      }
      if(!error)this.step++;

    },
    unfavCriteria(c){
      console.log("unfav",c);
      api.post(process.env.VUE_APP_API_URL+"/restrict/criteriasetfav",{
                criteria : c,
                fav : false,
              },
              {
                headers: {
                    'Content-Type': 'application/json',
              }
            }).then( () => {
              api.get(process.env.VUE_APP_API_URL+"/restrict/my_fav_criterias").then( (r) => {
                this.myfavcriterias = r.data;
                console.log(r.data);
                console.log(r);
              }).catch( (e) => console.log(e));
      }).catch( (e) => console.log(e));


    },
    selectAllFav(){
      var topush = this.favoriteCriteriaNotInAssessment;
      if(topush){
        topush.forEach((c) => {
        this.selectCriteria(c);

        });

      }
    },
    addStartupsToAssessment(){
        this.are_selected.forEach((s) => {

          const exists = this.internalAssessment.startups.some(
              (startup) => startup._id.$oid == s._id.$oid
          );

          // If the startup does not exist, call this.selectStartup
          if (!exists) {
              this.selectStartup(s);
          }
        });
        this.are_selected = [];

    },
    removeStartupsFromAssessment(){
      this.are_selected_assessed.forEach((s) => {
          this.unselectStartup(s);
      });
    },
    selectStartup(s){
      api.post(process.env.VUE_APP_API_URL+"/restrict/addStartupToAssessment",{
                startup : s,
                assessment : this.internalAssessment,
              },
              {
                headers: {
                    'Content-Type': 'application/json',
              }
            }).then( (r) => {
              console.log(r);
                this.internalAssessment.startups.push(s);
      }).catch( (e) => console.log(e));
        // this.internalAssessment.startups.push(s);
    },
    unselectStartup(s){
      api.post(process.env.VUE_APP_API_URL+"/restrict/removeStartupFromAssessment",{
                startup : s,
                assessment : this.internalAssessment,
              },
              {
                headers: {
                    'Content-Type': 'application/json',
              }
            }).then( () => {
              this.internalAssessment.startups = this.internalAssessment.startups.filter(item => item._id !== s._id);

      }).catch( (e) => console.log(e));
    },
    selectAllGroup(group){
      var topush = [];
      // console.log("GROUP",group);
      // topush = this.groupCriteriaNotInSelection(group);
      var assessmentIds = new Set(this.internalAssessment.criterias.map(c => c._id.$oid));
      var gg = group.criteriaList;
       topush = gg.filter(criteria =>
            !assessmentIds.has(criteria._id.$oid)
      );
      console.log("CRITERIAGROIPtoret",topush);
      if(topush){
        topush.forEach((c) => {
          api.post(process.env.VUE_APP_API_URL+"/restrict/addCriteriaToAssessment",{
                    criteria : c,
                    assessment : this.internalAssessment,
                  },
                  {
                    headers: {
                        'Content-Type': 'application/json',
                  }
                }).then( () => {


          }).catch( (e) => console.log(e));
          console.log("CCCCC",c);
          if(!this.internalAssessment.criterias) this.internalAssessment.criterias = [];
           if (!this.internalAssessment.criterias.some(item => item._id.$oid == c._id.$oid)) {
            this.internalAssessment.criterias.push(c); // Push only if not already in
          }
        });

      }

    },
    favCriteria(c){
      api.post(process.env.VUE_APP_API_URL+"/restrict/criteriasetfav",{
                criteria : c,
                fav : true,
              },
              {
                headers: {
                    'Content-Type': 'application/json',
              }
            }).then( () => {
              api.get(process.env.VUE_APP_API_URL+"/restrict/my_fav_criterias").then( (r) => {
                this.myfavcriterias = r.data;
                console.log(r.data);
                console.log(r);
              }).catch( (e) => console.log(e));
      }).catch( (e) => console.log(e));
    },
    selectCriteria(c){
      console.log(c);
      api.post(process.env.VUE_APP_API_URL+"/restrict/addCriteriaToAssessment",{
                criteria : c,
                assessment : this.internalAssessment,
              },
              {
                headers: {
                    'Content-Type': 'application/json',
              }
            }).then( () => {
              if(!this.internalAssessment.criterias) this.internalAssessment.criterias = [];
               if (!this.internalAssessment.criterias.some(item => item._id.$oid == c._id.$oid)) {
                this.internalAssessment.criterias.push(c); // Push only if not already in
              }

      }).catch( (e) => console.log(e));

    },
    removeCriteria(c){
      api.post(process.env.VUE_APP_API_URL+"/restrict/removeCriteriaFromAssessment",{
                criteria : c,
                assessment : this.internalAssessment,
              },
              {
                headers: {
                    'Content-Type': 'application/json',
              }
            }).then( () => {
              this.internalAssessment.criterias = this.internalAssessment.criterias.filter(item => item._id !== c._id);

      }).catch( (e) => console.log(e));
    },
    groupCriteriaNotInSelection(criteriagroup) {
      console.log("CRITERIAGROIP",criteriagroup);
      var assessmentIds = new Set(this.internalAssessment.criterias.map(c => c._id.$oid));
      var gg = criteriagroup.criteriaList;
      var toret = gg.filter(criteria =>
            !assessmentIds.has(criteria._id.$oid)
      );
      console.log("CRITERIAGROIPtoret",toret);
      return toret;
    },
   onBlur() {
     // Delay to allow interaction with the list before hiding it
     setTimeout(() => {
       this.showList = false;
     }, 200);
   },
   apply_filter(){
     this.basicFilters = this.basicFilters.map(obj => ({
       ...obj,
       toggled: false,
       toggled_sidebar: false
     }));
     this.showMatching = false;
     this.showSidePanelBasic = false;
     console.log("BASIC FILTER",this.basicFilters);
     this.loading = true;
     api.post(process.env.VUE_APP_API_URL+"/restrict/basic_filter_from_nothing",
         {
             basicFilters : this.basicFilters,
         },
         {
           headers: {
               'Content-Type': 'application/json',
         }
       }).then( (r) => {
       console.log("POOLFILTERED",r.data);
       this.startups = r.data;
       this.startups_quicksearch = r.data;
       console.log("YTFSDFSFDDFGSFG",this.startups_quicksearch);
       this.quicksearch = "";
       this.loading = false;
       this.filterStartups(this.quicksearch);
     }).catch( (e) => {console.log(e);this.loading = false;});
   },
   filterStartups(v) {
      console.log(v);
      this.are_selected = [];
      this.allSelect = false;
      if(v){
        this.startups_quicksearch = this.startups.filter(obj => {
          var isInInternalAssessment = this.internalAssessment.startups.some(internalStartup => internalStartup._id.$oid == obj._id.$oid);

          return obj.name.toLowerCase().includes(v.toLowerCase()) && !isInInternalAssessment;
        });
      }
      else{
         this.startups_quicksearch = this.startups.filter(obj => {
          var isInInternalAssessment = this.internalAssessment.startups.some(internalStartup => internalStartup._id.$oid == obj._id.$oid);

          return !isInInternalAssessment;
        });
      }

      // Perform filtering based on search query and exclude already selected startups

    },
    selectAllStartupsPool(pool){
      pool.candidates.forEach((item) => {
        this.are_selected.push(item);
      });
      pool.allSelected = true;
    },
    unselectAllStartupsPool(pool){
      this.are_selected = this.are_selected.filter(selectedItem => {
          // Check if the selected item's _id.$oid is not in pool.candidates
          return !pool.candidates.some(candidate => candidate._id.$oid == selectedItem._id.$oid);
      });
        pool.allSelected = false;
    },
    selectAllStartups(){
      this.startups_quicksearch.forEach((item) => {
        this.are_selected.push(item);
      });
      this.allSelect = true;
    },
    unselectAllStartups(){
      this.are_selected = [];
      this.allSelect = false;
    },
    pleaseDeleted(v){
      console.log(v);
      if(v){
        if(v._id.$oid){
          var c = {
            _id : v._id.$oid,
          };
          api.post(process.env.VUE_APP_API_URL+"/restrict/remove_criteria",
              c,
              {
                headers: {
                    'Content-Type': 'application/json',
              }
            }).then( (r) => {
              console.log(r);
              toast.success("Criteria successfully removed");

              api.get(process.env.VUE_APP_API_URL+"/restrict/mycriteriabygroup").then( (r) => {
                this.criteriaGroups = r.data;
                console.log("criterias : ",r.data);
                console.log(r);
              }).catch( (e) => console.log(e));
            }).catch( (e) => {
              console.log(e);
               toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
        }
      }

    },
    handleStepChange(newval){
      console.log("this.internalAssessment",this.internalAssessment);
      switch (newval) {
        case 1:
            this.pageInfo.subTitle = this.$t("Define scope");
            this.$nextTick(() => {
              if(this.$refs.linkplusContentEditor)this.$refs.linkplusContentEditor.setHTML(this.internalAssessment.description );
            });

          break;
        case 2:
            this.pageInfo.subTitle = this.$t("Define criteria");
          break;
          case 3:
              this.pageInfo.subTitle = this.$t("Define feedback areas");
            break;
            case 4:
                this.pageInfo.subTitle = this.$t("Select innovators");

                if(this.internalAssessment.project){

                    api.get(process.env.VUE_APP_API_URL+"/restrict/project_lists/"+this.internalAssessment.project.$oid).then( (r) => {
                      // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
                      // console.log();
                      // var temp = _.merge(this.candidatespool, r.data)
                      console.log(r.data);
                      this.project_lists = r.data;
                      if(this.project_lists.length > 0)this.showMoreStartups = false;
                      else this.showMoreStartups = true;

                    }).catch( (e) => {
                      console.log(e);
                       toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ");

                     });


                  //also query list from project if there is a projet
                  console.log(this.internalAssessment.project.$oid);
                }
                else{
                  this.project_lists = [];
                  this.showMoreStartups = true;

                }

              break;
              case 5:
                  this.pageInfo.subTitle = this.$t("Add judges");
                  console.log(this.internalAssessment.emailContent);
                  this.$nextTick(() => {
                    if(this.internalAssessment.emailContent){
                      if(this.$refs.emailContentForAssessment)this.$refs.emailContentForAssessment.setHTML(this.internalAssessment.emailContent);

                    }
                    else{
                      if(this.$refs.emailContentForAssessment)this.$refs.emailContentForAssessment.setHTML(this.default_content_for_email);
                    }

                  });

                break;
        default:
        this.pageInfo.subTitle = this.$t("Define scope");
      }
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
    }
  },
  mounted(){
    this.dict_loaded = false;
    // if(localStorage.getItem('currentFilterSet')){
    //   var fromCookie = JSON.parse(localStorage.getItem('currentFilterSet'));
    //   this.selected_filters = fromCookie;
    // }
    var requestarray = this.basicFilters.filter(obj => ['revenue', 'location','submitDate'].every(key => obj.key !== key));

    requestarray.forEach((item, index) => {

      var dict_key = (item.dict) ? item.dict : item.key;
      if(dict_key != 'location' && dict_key != "revenue" && dict_key != "submitDate" && dict_key != "linkplus" && dict_key != "submitDate"){
        api.get(process.env.VUE_APP_API_URL+"/restrict/dict/dict_"+dict_key,{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r.data);
          item.values_list = r.data;
          if(index == requestarray.length - 1){
            console.log("Dict loaded");

          }

        }).catch( error => {
          if(error.response.data.message) toast.error(error.response.data.message);
          else toast.error("Sorry, an error occurs. Please try again !");
        })
      }

          this.linkplus_loaded = true;
    this.dict_loaded = true;
    });

    console.log("idroute",this.$route.params.id);
    if(this.$route.params.id){


      if(this.$route.params.id != "undefined"){
        api.get(process.env.VUE_APP_API_URL+"/restrict/assessment/"+this.$route.params.id).then( (r) => {
          this.internalAssessment = r.data;
          console.log("get",r.data);
          console.log(r);
          this.$nextTick(() => {
            if(this.$refs.linkplusContentEditor)this.$refs.linkplusContentEditor.setHTML(this.internalAssessment.description );
            if(this.internalAssessment.emailContent){
              if(this.$refs.emailContentForAssessment)this.$refs.emailContentForAssessment.setHTML(this.internalAssessment.emailContent);

            }
            else{
              if(this.$refs.emailContentForAssessment)this.$refs.emailContentForAssessment.setHTML(this.default_content_for_email);
            }


      //      if(this.$refs.emailContentForAssessment)this.$refs.emailContentForAssessment.setHTML(this.internalAssessment.emailContent);
          });
          if(this.internalAssessment.deadline){

            this.deadlineDateFormated = this.internalAssessment.deadline.date.split(' ')[0];
          }

        }).catch( (e) => console.log(e));
       }
    }
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
     api.post(process.env.VUE_APP_API_URL+"/restrict/basic_filter_from_nothing",
         {
             basicFilters : this.basicFilters,
         },
         {
           headers: {
               'Content-Type': 'application/json',
         }
       }).then( (r) => {
       console.log('callback',r.data);
       this.startups = r.data;
       this.startups_quicksearch = this.startups;
       this.loading = false;
       this.filterStartups(this.quicksearch);
     }).catch( (e) => {console.log(e);this.loading = false;});
     api.get(process.env.VUE_APP_API_URL+"/restrict/projects").then( (r) => {
       this.projects = r.data;
       console.log(r.data);
       console.log(r);
     }).catch( (e) => console.log(e));
     api.get(process.env.VUE_APP_API_URL+"/restrict/my_fav_criterias").then( (r) => {
       this.myfavcriterias = r.data;
       console.log(r.data);
       console.log(r);
     }).catch( (e) => console.log(e));
     api.get(process.env.VUE_APP_API_URL+"/restrict/mycriteriabygroup").then( (r) => {
       this.criteriaGroups = r.data;
       console.log("criterias : ",r.data);
       console.log(r);
     }).catch( (e) => console.log(e));

     api.get(process.env.VUE_APP_API_URL+"/restrict/get_innodata/6707d104621213a6cb50d58e").then( (r) => {
       // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
       // console.log();
       // var temp = _.merge(this.candidatespool, r.data)
       console.log(r.data);
       this.default_content_for_email = r.data.datavalue;
     }).catch( (e) => {
       console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
     api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount").then( (r) => {
       // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
       // console.log();
       // var temp = _.merge(this.candidatespool, r.data)
       console.log(r.data);
       this.userInfo = r.data;
     }).catch( (e) => {
       console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });

      if(this.$route.query.step){
          this.step = this.$route.query.step;
          if(this.step == 4){
            if(this.internalAssessment.project){

                api.get(process.env.VUE_APP_API_URL+"/restrict/project_lists/"+this.internalAssessment.project.$oid).then( (r) => {
                  // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
                  // console.log();
                  // var temp = _.merge(this.candidatespool, r.data)
                  console.log(r.data);
                  this.project_lists = r.data;
                  if(this.project_lists.length > 0)this.showMoreStartups = false;
                  else this.showMoreStartups = true;
                }).catch( (e) => {
                  console.log(e);
                   toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
                 });


              //also query list from project if there is a projet
              console.log(this.internalAssessment.project.$oid);
            }
            else{
              this.project_lists = [];
              this.showMoreStartups = true;
            }
          }
      }else{
        this.step = 1;
      }

  },
  computed:{
    tomorrowDate() {
     const tomorrow = new Date()
     tomorrow.setDate(tomorrow.getDate() + 1)
     return tomorrow.toISOString().split('T')[0] // Returns YYYY-MM-DD format
   },
   shownList(){
      return this.project_lists?.filter(project => project.showIT === true) || [];

   },
    favoriteCriteriaNotInAssessment() {
     var assessmentIds = new Set(this.internalAssessment.criterias.map(c => c._id.$oid));
     var seenCriteriaIds = new Set();
     console.log("assessmentIds",assessmentIds);
     var toret = [];
     console.log("myfavcriterias",this.myfavcriterias);
     if(this.myfavcriterias.length){
       toret = this.myfavcriterias.flatMap(group =>{
         var gg = (group.criteriaList || []);
           return gg.filter(criteria =>{
             if (!assessmentIds.has(criteria._id.$oid) && !seenCriteriaIds.has(criteria._id.$oid)) {
               seenCriteriaIds.add(criteria._id.$oid); // Add to seenCriteriaIds to avoid duplicates
            return true;
          }
          return false;
        })

       });
     }

     console.log("toret",toret);
     return toret;
   },
   filterList() {
     var searchTerm = this.criteriaSearch.toLowerCase();

     // Map over all groups to preserve them, while filtering their criteriaList
     var filteredGroups = this.criteriaGroups.map(group => {
       const filteredCriteriaList = group.criteriaList.filter(item =>
         item.name.toLowerCase().includes(searchTerm)
       );

       // Return the group with the filtered criteriaList
       return {
         ...group,
         criteriaList: filteredCriteriaList
       };
     });

     return filteredGroups;
   },

   allCriteriaNotInAssessment() {
    var assessmentIds = new Set(this.internalAssessment.criterias.map(c => c._id.$oid));
    var toret = this.criteriaGroups.flatMap(group =>
        group.criteriaList.filter(criteria =>
          !assessmentIds.has(criteria._id.$oid)
        )
    );
    console.log("toret",toret);
    return toret;
  },

},
watch:{
  'internalAssessment.startups': {
      deep: true, // Deep watch in case the array is updated or mutated
      handler() {
        console.log("intern Watcher");
        this.filterStartups(this.quicksearch);
      }
    },

  quicksearch: function(v){
    this.filterStartups(v);
   },
  step: {
    handler(newval){
      console.log("STEP WATCHER TRIGGERED");
      this.handleStepChange(newval);
   },
   immediate: false
  }
}

}
</script>
<style media="screen">
  .internalAssessment .ql-editor{
    min-height:200px;
    font-family: 'Montserrat' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value]::before {
    content: attr(data-value) !important;
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Roboto"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Roboto"]::before {
    font-family: 'Roboto' !important;
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="OpenSans"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="OpenSans"]::before {
    font-family: 'Open Sans' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Lato"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Lato"]::before {
    font-family: 'Lato' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Montserrat"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Montserrat"]::before {
    font-family: 'Montserrat' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SourceSansPro"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SourceSansPro"]::before {
    font-family: 'Source Code Pro' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Poppins"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Poppins"]::before {
    font-family: 'Poppins' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Raleway"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Raleway"]::before {
    font-family: 'Raleway' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Ubuntu"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Ubuntu"]::before {
    font-family: 'Ubuntu' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Oswald"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Oswald"]::before {
    font-family: 'Oswald' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Merriweather"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Merriweather"]::before {
    font-family: 'Merriweather' !important;
  }

  .ql-font-Oswald{
        font-family: 'Oswald' !important;
  }
  .ql-font-Merriweather{
        font-family: 'Merriweather' !important;
  }
  .ql-font-Ubuntu{
          font-family: 'Ubuntu' !important;
  }
  .ql-font-Raleway{
          font-family: 'Raleway' !important;
  }
  .ql-font-Poppins{
          font-family: 'Poppins' !important;
  }
  .ql-font-Montserrat{
          font-family: 'Montserrat' !important;
  }
  .ql-font-Lato{
          font-family: 'Lato' !important;
  }
  .ql-font-Oswald{
          font-family: 'Oswald' !important;
  }

  .ql-font-OpenSans{
          font-family: 'Open Sans' !important;
  }

  .ql-font-SourceSansPro{
      font-family: 'Source Code Pro' !important;
  }

  .ql-snow .ql-picker.ql-font {
    width: 150px !important;
    white-space: nowrap;
  }

  .ql-container{
    font-size:14px !important;
  }
</style>
<style scoped>

.tcenter{
  text-align:center;
}
.thank_you_container{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
  padding-bottom: 100px;
}
.thank_you{
  background:#F0F5FA;
  padding:50px;
  padding-bottom:0px;
  border-radius:50px;
  max-width:635px;
}
.thank_you .titre_1{
  color:#3783C5;
  font-weight:600;
  font-size:27px;
}
.thank_you .text_1{
  margin-top:30px;
  margin-bottom:20px;
  color:#04246A;
  font-size:15px;
}
.pointerCursor{
  cursor:pointer !important;
}
.forceWidth300{
  width:300px;
}
.flexcentergapbetween{
  display:flex;
  align-items:center;
  justify-content:space-between;
}
.internalAssessment{
  padding-top:50px;
  padding-bottom:50px;
}
.internalAssessment_inner{
    padding: 50px;
    padding-top:25px;
    border-radius:20px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
}
.aname{
  color:#04246A;
}

.assessment-navigation {
    display: flex;
    border-radius:20px;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    width: 100%;
        background-color: #fff;
        padding:20px;
}


.gold-button {
    color: #BF9000;
    background: #FFF 0% 0% no-repeat padding-box;
    padding: 10px 27px;
    border: none;
    display: flex;
    gap:10px;
    align-items: center;
    cursor: pointer;
    border-radius: 200px;
    border:1px solid #BF9000;
}
.preview-button {
    color: #3783C5 !important;
    background: #fff 0% 0% no-repeat padding-box;
    border:1px solid #3783C5 !important;
    padding: 10px 27px;
    border: none;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 200px;
    text-transform:uppercase;
}
.next-button {
    color: #fff;
    background: #3783C5 0% 0% no-repeat padding-box;
    border:1px solid #3783C5;
    padding: 10px 27px;
    border: none;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 200px;
    text-transform:uppercase;
}
.back-button{
      color: #3783C5;
      background: # 0% 0% no-repeat padding-box;
      padding: 10px 20px;
      border: none;
      display: flex;
      align-items: center;
          cursor: pointer;
          gap:5px;
          border-radius: 200px;
          border:1px solid #3783C5;
          text-transform:uppercase;

}


.status{
  gap:5px;
}
.status.inprogress {
    display: flex;
    align-items: center;
    background-color: #FFAA2A;
      padding: 5px 20px !important;
    border-radius: 15px;
}

.status.inprogress .status-text {
    color: #fff;
    font-size: 14px;
}
.status.draft {
    display: flex;
    align-items: center;
    background-color: #6C68A2;
      padding: 5px 20px !important;
    border-radius: 15px;
}


.status.draft .status-text {
    color: #fff;
    font-size: 14px;
}

.status.completed {
    display: flex;
    align-items: center;
    background-color: #4ADE80;
      padding: 5px 20px !important;
    border-radius: 15px;
}

.status.completed .status-text {
    color: #FFF;
    font-size: 14px;
}


.status.closed {
    display: flex;
    align-items: center;
    background-color: #ADB3B5;
      padding: 5px 20px !important;
    border-radius: 15px;
}

.status.closed .status-text {
    color: #fff;
    font-size: 14px;
}

.next-button .v-img{
  margin-left:10px;
}

.left{

  flex: 1;
  display: flex;
  align-items: center;
  gap: 20px;
}
@media screen and (max-width:990px){
  .assessment-navigation{
    flex-direction: column;
        align-items: left;
    gap:20px;
    padding: 10px;
  }

  .left {
    flex-wrap: wrap;
  }
  .availableLists,
  .availableStartups,
  .selectedStartups,
  .internalAssessment_inner{
    padding:20px !important;
  }
}
.oneInfoAboutTitle{
  font-size:14px;
  font-weight:700;
  color:#000;
}
.mainColTitle{
  color:rgba(4, 36, 106, 1);
  font-size:20px;
  font-weight: 700;
}
.internalAssessmentContent2Col .criterias,
.internalAssessmentContent2Col .judges{
  padding:20px;
}
.internalAssessmentContent2Col .criterias{

  border:1px solid rgba(55, 131, 197, 1);
  border-radius:20px;
}
.criteriaList{
  display:flex;
  flex-direction: column;
  gap:20px;
  margin-top:20px;
}
.oneCriteria .criteriaHead{
  display:flex;
  gap:10px;
  position:relative;
}
.oneCriteria .criteriaHead .criteriaName{
  font-weight: 700;
  font-size:14px;
  color:rgba(10, 32, 113, 1);
}
  .criteriaName{
      cursor:pointer;
  }
.criteriaHead .v-img{
  width:18px;
  flex:none;
}

.vsliderIndicator{
  font-size:15px;
  font-weight: 500;
  color:#000;
}

.selectIt{


display:flex;
align-items: center;
gap: 10px;
}
.selectIt input{
  width:24px;
  height:24px;
}

.criteriaVoting{
  display:flex;
  gap:20px;
  align-items: center;
}
.criteriaVoting .slider{
  width:70%;
}


.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: rgba(4, 36, 106, 1);
  font-weight: 600;
  margin-bottom:10px;
}
.zone_input_name small{
  text-align: left;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  margin-bottom:10px;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  position:relative;
}

.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
box-sizing: border-box;

height: 40px;
padding: 5px;
width:100%;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}

textarea.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
margin-top:20px;
margin-bottom: 20px;
padding: 5px;
 resize: none;
 height:60px;

}

.feedBacks{
  margin-top:50px;
  border-top:1px solid #125AA433;
  padding-top:50px;
  margin-bottom: 50px;
}

.internalAssessmentContent2Col{
  margin-top:50px;
}


.selectedStartups{
  margin-top:50px;
  padding:50px;
  background:rgba(245, 250, 255, 1);
  border-radius: 15px;
}

.availableLists{
  margin-top:50px;
  padding:50px;

}
.availableLists .titleText,
.availableStartups .titleText,
.selectedStartups .titleText{
  font-size:20px;
  font-weight: 700;
  text-align:center;
  color:rgba(4, 36, 106, 1);
}
.availableStartups{

  padding:50px;
}


  .selectCandidateCard{
    background:#FFF;
  }
  .selectCandidateCard  .candidate_card_head{
      color: #4c81c0;
      padding: 10px 0px;
      background: #FFF;
      text-transform: uppercase;
      font-weight: bold;
    margin-left: 20px;
    margin-right: 20px;
      display:flex;
      align-content: center;
        align-items: center;
    gap:10px;
    min-height: 60px;

  }
.candidateList,
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.clickable{
  cursor:pointer;
}
.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content{
  padding:10px 20px ;
  flex-grow: 1;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}
.oneGroupHeadd{
  align-items: center;
}

  .selectCandidateCard .titreProperty{
    color:rgba(75, 82, 162, 1);
    font-size:14px;
    font-weight: 400;
    width:100%;
    display:block;
  }
  .selectCandidateCard .valueProperty{
    color:rgba(10, 32, 113, 1);
    font-size:14px;
    font-weight: 700 !important;
    width:100%;
    display:block;
  }

  .footer_link_cc{
 padding-left:20px;
 padding-right:20px;
 margin-bottom:20px;
 margin-top:20px;
  }
  .footer_link_cc a{
      display:block;
      width:100%;
      background:#4c81c0;
      color:#FFF;
      border-radius: 10px;
      padding:10px;
      text-align: center;
  }

  .listOfSelectedStartups{
    margin-top:25px;
  }


  .listOfJudges{
    display:flex;
    gap:20px;
    margin-top:10px;
    flex-wrap: wrap;
  }



  .oneJudgeSelected{
    background:#480C831A;
    color:#480C83;
    padding:5px 20px;
    display:flex;
    gap:10px;
    border-radius: 200px;
    border: 1px solid #480C831A;
    position:relative;
  }
  .subTitleJudge{
    font-size:16px;
    font-weight: 700;
    color:#04246A;
    margin-bottom:10px;
    display:block;
    width:100%;
  }

  .judgesWithLicenses
  {
      padding-top:35px;
  padding-bottom:25px;
  border-bottom: 1px solid #BACFE5;
  }
  .judgesWithoutLicences{
    padding-top:35px;
  padding-bottom:25px;
  border-bottom: 1px solid #BACFE5;
  }

  .oneInfoAboutValue p{
    padding:0;
    margin:0;
  }

  .result-list {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #ccc;
    border-radius: 5px;
    min-width:350px;
  }

  .group-item {
    padding: 10px;
  }

  .group-header {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    color: #1565c0;
  }

  .item {
    display: flex;
    align-items: center;
    padding: 5px 0;
    gap:5px;
  }

.disabledCriteriaSelection{
  opacity:.7;
  color:#AAA;
  cursor:default;
}
  .v-btn {
    margin-right: 10px;
  }

  .v-card {
    max-width: 400px;
    position: absolute;
    z-index: 10;
  }


  .listOfAvailableCriteria,
  .listOfSelectedCriteria{
    display:flex;
    gap:20px;
    margin-top:20px;
    flex-wrap: wrap;
  }



  .listOfSelectedCriteria .oneCriteriaSelected{
    background:#3982C4;
    color:#FFF;
    padding:5px 20px;
    display:flex;
    gap:10px;
    border-radius: 200px;
    border: 1px solid #3982C4;
    position:relative;
    flex-wrap:wrap;
  }

  .oneFavoriteCriteria{
    background:#3982C41A;
    color:#3982C4;
    padding:5px 20px;
    display:flex;
    gap:10px;
    border-radius: 200px;
    border: 1px solid #3982C41A;
    position:relative;
        flex-wrap:wrap;
  }

  .oneClassicCriteria{
    background:#fff;
    color:#000;
    padding:5px 20px;
    display:flex;
    gap:10px;
    border-radius: 200px;
    border: 1px solid #000;
    position:relative;
        flex-wrap:wrap;
  }
  .oneGroupHead{
    display:flex;
    gap:10px;
  }
  .groupHeadd{
    align-items: center;
  }

  .groupTitle{
    font-weight:700;
    color:#3982C4;
    font-size:16px;
  }

  .groupsList{
    display:flex;
    flex-direction: column;
    gap:40px;
    margin-top:20px;
  }

  .titleSelectedZone{
    font-size:16px;
    font-weight: 700;
    color:#04246A;
  }

  .selectedZone{
    margin-top:50px;
    padding: 30px;
  background: #EBF2F9;
  border-radius: 20px;
  }
  .favoriteZone{
    margin-top:50px;
  }
  .allCriteriaZone{
    margin-top:20px;
  }

  .lineDivider{
    width:100%;
    height:2px;
    margin-top:50px;
    background:#E1E3E6;
  }
  .searchbox{
    margin-bottom:25px;
  }
  #criteriaSearch{
    border: 1px solid #E1E3E6;
      padding: 10px 15px;
      margin-top: 5px;
      min-width: 350px;
  }

  .searchboxInner{
    display:inline-block;
    position:relative;
  }

  .searchboxInner::after{
    position:absolute;
    top: calc(50% - 11px);
    right:10px;
    content:  url('@/assets/loupe.svg');
  }


  .prev_step_btn{
    color:#3783C5;
    background: #fff 0% 0% no-repeat padding-box;
    border: 1px solid #3783C5;
    border-radius: 200px;
    opacity: 1;
      padding: 7px 20px;
    margin:5px;
    display:flex;
    gap:10px;
    justify-content: center;
  align-content: center;
  align-items: center;
  }

  .selectAllArea{
    display: flex;
  gap: 10px;
  align-content: center;
  align-items: center;
  }
  .disableFeedBack span {
    color:#04246A;
    font-weight: 600;
  }

  .oneFeedbackContent{
    margin-top:25px;
  }

  .candidate_card .candidate_links .selectIt{
    font-size:12px;
    line-height: 15px;
    letter-spacing: 0px;
    color: #3783C5;
    text-transform: uppercase;
    flex:0.5;
    align-items: flex-end;

  }

  .selectIt_fw{
    flex:1;
    align-items: flex-start;
  }
  .selectIt_fw label{
  display:flex;
  align-items: center;
  gap: 5px;
  justify-content: start;
  }
   .selectIt label{
  display:flex;
  align-items: center;
  gap: 5px;
  justify-content: end;
  }
   .selectIt input{
    width:24px;
    height:24px;
  }



  .checkbox {
    cursor: pointer;
    display: flex;
    align-items: center;
    /* margin-bottom:20px; */
  }
  .checkboxItem{
    margin-bottom: 20px;
  }
   .checkbox__input {
    position: absolute;
    width: 1.375em;
    height: 1.375em;
    opacity: 0;
    cursor: pointer;
  }

  .checkbox__input:checked + .checkbox__icon .tick {
    stroke-dashoffset: 0;
  }
  .checkbox__icon {
    width: 1.375em;
    height: 1.375em;
    flex-shrink: 0;
    overflow: visible;
  }
  .checkbox__icon .tick {
    stroke-dasharray: 20px;
    stroke-dashoffset: 20px;
    transition: stroke-dashoffset 0.2s ease-out;
  }
  .checkbox__label {
    margin-left: 0.5em;
  }

  .filtres{

    padding:0;
  }
  .filtres_head .customH2{
    display: block;
    width: 100%;
    background: #3783C5;
    color: #FFF;
    padding: 10px;
  }
  .filtre_list{
    padding:10px;
  }


  .prev_step_btn_small{
    border: 1px solid #3783C5;
    border-radius: 200px;
    opacity: 1;
    padding: 5px 20px;
    color:#3783C5;
      margin:5px;
      text-decoration: none;
  }

  .next_step_btn_small, .next_step_btn_small:hover {
    background: #3783C5 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 6px #00000029 !important;
    border: 1px solid #3783C5 !important;
    border-radius: 200px;
    opacity: 1;
    padding: 5px 20px;
    color: #FFF;
    margin: auto;
    display:block;
    margin-top:20px;
    margin-bottom: 20px;
  }
  .startup_zone_legend{
    align-self: top;
  }
  .zone_startups{
      align-self: center;
  }
  .zone_title{
    font-size: 25px;
    color: #3783C5;
    font-weight: 700;
    text-align: center;
    display:block;
    width:100%;
    text-align:center;

  }
  .zone_number{
    font-size: 16px;
    color: #3783C5;
    font-weight: 700;
    text-align: center;
    display:block;
    width:100%;
    text-align:center;

  }

  .row.zone{
    padding-bottom: 50px;
    padding-top:25px;
  }

  .startup_zone_legend.stickit .legend{
    position: sticky;
      top: 50%; /* Adjust the top value as needed */
  }

  .startup_zone_legend:not(.stickit){
    align-self: center;
  }

  .alert{
    margin:0;
  }



  .startup_selection_section{
    position:relative;
  }

  .filtre_list{
    display: grid;
      grid-template-columns: auto auto auto;
      grid-template-columns: 1fr 1fr 1fr;
      grid-auto-rows: 100%;
      gap:10px;
  }

  .pad-50{
    padding-left:50px;
    padding-right:50px;
  }
  @media screen and (max-width: 690px){
    .candidate_card .candidate_links{
      flex-direction: column;
      flex-wrap: wrap;
      gap: 20px
    }
    .candidate_pool{
        padding: 20px;
      }
      .candidate_card .candidate_links .details{
        border-right: none;
        border-bottom:1px solid #DDD;
        padding-bottom: 20px;
      }
      .candidate_card .candidate_links .selectIt label{
      display:flex;
      align-items: center;
      gap: 5px;
      justify-content: start;
      flex-direction: row-reverse;
      }
      .filtre_list {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-template-columns: 1fr;
    grid-auto-rows: 100%;
    gap: 10px;
  }
  }



  .candidate{
    margin-top:20px;
    margin-bottom: 20px;
  }
  .candidate_card{
    border: 2px solid #DDDDDD;
  border-radius: 15px;
  z-index: 5;
  height:100%;
  display: flex;
  flex-direction: column;
  }
  .candidate_card .candidate_image{
    width:100%;
    height:200px;
    object-fit: cover;
    z-index: 1;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .clickable{
    cursor:pointer;
  }
  .candidate_card .candidate_links{
    display:flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 20px 5px;

    margin: 0;
  }
  .candidate_card .candidate_info_content .candidate_name{
    font-size:18px;
    line-height:21px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  display:block;
  font-weight: 500;
  }

  .candidate_card .candidate_info_content .candidate_desc{
    font-size:16px;
    line-height:22px;
    margin-top:10px;
    display:block;
    margin-bottom:10px;
  }
  .candidate_card .candidate_links .details{
    font-size:12px;
    line-height: 15px;
    border-right: 1px solid #DDD;
    display:flex;
    align-items: center;
    text-transform: uppercase;
    color: #3783C5;
    flex: 0.5;

  }
  .candidate_card .candidate_links .details a{
      text-decoration: none;
  }
  .candidate_card .candidate_links .details img{
    margin-right:5px;
  }
  .candidate_card .candidate_links .selectIt{
    font-size:12px;
    line-height: 15px;
    letter-spacing: 0px;
    color: #3783C5;
    text-transform: uppercase;
    flex:0.5;
    align-items: flex-end;

  }

  .candidate_card .candidate_links .selectIt_fw{
    flex:1;
    align-items: flex-start;
  }
  .candidate_card .candidate_links .selectIt_fw label{
  display:flex;
  align-items: center;
  gap: 5px;
  justify-content: start;
  }
  .candidate_card .candidate_links .selectIt label{
  display:flex;
  align-items: center;
  gap: 5px;
  justify-content: end;
  }
  .candidate_card .candidate_links .selectIt input{
    width:24px;
    height:24px;
  }
  .candidate_card .candidate_links .details.noBorder{
    border-right: none;

  }


  .titre{
    margin-bottom: 20px;
    color: #3783C5;
    text-transform: uppercase;
  }


  .checkbox {
    cursor: pointer;
    display: flex;
    align-items: center;
    /* margin-bottom:20px; */
  }
  .checkboxItem{
    margin-bottom: 20px;
  }
  .checkbox__input {
    position: absolute;
    width: 1.375em;
    height: 1.375em;
    opacity: 0;
    cursor: pointer;
  }
  .checkbox__input:checked + .checkbox__icon .tick {
    stroke-dashoffset: 0;
  }
  .checkbox__icon {
    width: 1.375em;
    height: 1.375em;
    flex-shrink: 0;
    overflow: visible;
  }
  .checkbox__icon .tick {
    stroke-dasharray: 20px;
    stroke-dashoffset: 20px;
    transition: stroke-dashoffset 0.2s ease-out;
  }
  .checkbox__label {
    margin-left: 0.5em;
  }

  .filtres{

    padding:0;
  }
  .filtres_head .customH2{
    display: block;
    width: 100%;
    background: #3783C5;
    color: #FFF;
    padding: 10px;
  }
  .filtre_list{
    padding:10px;
  }


  .prev_step_btn_small{
    border: 1px solid #3783C5;
    border-radius: 200px;
    opacity: 1;
    padding: 5px 20px;
    color:#3783C5;
      margin:5px;
      text-decoration: none;
  }

  .next_step_btn_small, .next_step_btn_small:hover {
    background: #3783C5 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 6px #00000029 !important;
    border: 1px solid #3783C5 !important;
    border-radius: 200px;
    opacity: 1;
    padding: 5px 20px;
    color: #FFF;
    margin: auto;
    display:block;
    margin-top:20px;
    margin-bottom: 20px;
  }
  .startup_zone_legend{
    align-self: top;
  }
  .zone_startups{
      align-self: center;
  }
  .zone_title{
    font-size: 25px;
    color: #3783C5;
    font-weight: 700;
    text-align: center;
    display:block;
    width:100%;
    text-align:center;

  }
  .zone_number{
    font-size: 16px;
    color: #3783C5;
    font-weight: 700;
    text-align: center;
    display:block;
    width:100%;
    text-align:center;

  }

  .row.zone{
    padding-bottom: 50px;
    padding-top:25px;
  }

  .startup_zone_legend.stickit .legend{
    position: sticky;
      top: 50%; /* Adjust the top value as needed */
  }

  .startup_zone_legend:not(.stickit){
    align-self: center;
  }

  .alert{
    margin:0;
  }



  .startup_selection_section{
    position:relative;
  }

  .filtre_list{
    display: grid;
      grid-template-columns: auto auto auto;
      grid-template-columns: 1fr 1fr 1fr;
      grid-auto-rows: 100%;
      gap:10px;
  }

  .pad-50{
    padding-left:50px;
    padding-right:50px;
  }
  @media screen and (max-width: 690px){
    .candidate_card .candidate_links{
      flex-direction: column;
      flex-wrap: wrap;
      gap: 20px
    }
    .candidate_pool{
        padding: 20px;
      }
      .candidate_card .candidate_links .details{
        border-right: none;
        border-bottom:1px solid #DDD;
        padding-bottom: 20px;
      }
      .candidate_card .candidate_links .selectIt label{
      display:flex;
      align-items: center;
      gap: 5px;
      justify-content: start;
      flex-direction: row-reverse;
      }
      .filtre_list {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-template-columns: 1fr;
    grid-auto-rows: 100%;
    gap: 10px;
  }
  }


  .candidate_comments{
    padding: 20px 50px;
    border-top: 1px solid #DDD;
    margin-top:auto;
  }
  .candidate_comments .one_comment{
    margin-top:10px;
    margin-bottom: 10px;
    font-size:12px;
    line-height:15px;
      position:relative;
  }
  .candidate_comments .one_comment:after {
    content: ""; /* This is necessary for the pseudo element to work. */
       display: block; /* This will put the pseudo element on its own line. */
       margin: 0 ; /* This will center the border. */
       width: 20%; /* Change this to whatever width you want. */
       padding-top: 10px; /* This creates some space between the element and the border. */

       border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
  }
  .candidate_comments small{
    font-size:12px;
  }

  .add_new_comment{
    font-size:12px;
    line-height:15px;
    color: #3785C5;
    text-transform: uppercase;
    margin-top:20px;
  }
  .add_new_comment img{
    width: 20px;
    margin-right: 10px;
  }


  .all_candidates_download_zone{
      padding: 50px;
      background: #FFF;
      background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;
  margin-bottom:50px;
  }


  .title{
    font-size: 24px;
    line-height:29px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  display:block;
  margin-bottom: 10px;
  }


  .all_candidates_download_zone .title{

    font-size: 20px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  display:block;
  margin-bottom: 10px;
  font-weight:500;
  cursor : pointer;
  }


  .all_candidates_download_zone .description{
    display:block;
    margin-top:10px;
    margin-bottom: 20px;
    width:100%;
  }
  .all_candidates_download_zone a{
    color:#B38D2F !important;
  }

  .next_step_btn{
    background: #3783C5 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #3783C5;
    border-radius: 200px;
    opacity: 1;
    padding: 14px 37px;
    color:#FFF;
    margin:5px;
  }
  .next_step_btn img.left{
    margin-right:10px;
  }
  img.goFullWhite{
  filter: brightness(0) invert(1);
  }

  .pool_subtitle{
    font-size: 24px;
    line-height:29px;
  letter-spacing: 0px;
  color: #3783C5;
  display:block;
  }
  .mb10{
    margin-bottom:10px;
  }
  .mt20{
    margin-top:20px;
  }


  /* .selectAll{
    border: 1px solid #CCC;
    border-radius: 200px;
    padding: 5px 20px;
    margin: auto;
      margin-top: auto;
    display: block;
    margin-top: 20px;
  } */
  .goToRight{

  }

  .candidate_card_head{
  background: transparent linear-gradient(270deg, #3783C5 0%, #1368B2 100%) 0% 0% no-repeat padding-box;
    padding: 10px;
    color: #FFF;
    text-transform: uppercase;
    font-weight: bold;
    border-radius: 10px 10px 0px 0px;
    display:flex;
    align-content: center;
      align-items: center;
  gap:10px;
  min-height: 60px;
  }
  .candidate_card_head .name{
    flex:1;
  }

  .score {
    height: 70px;
    width: 70px;
    -webkit-clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    text-align: center;
    background: #B38D2F;
    color: white;
    font-size:17px;
  }

  .score::before {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    content: '';
  }
  .candidate_card .candidate_info_content{
    padding:20px;
    flex-grow: 1;
  }
  .footer{
  padding-left: 20px;
    padding-right: 20px;
      padding-bottom: 10px;
    font-weight:bold;
    text-transform: uppercase;
    color:#B38D2F !important;
    font-size:14px;
    display:flex;
    flex-wrap:wrap;
    gap:10px;
  }

  .footer a{
    margin-left: auto;
  }
  .footer *{
    color:#4c81c0 !important;
    font-size:14px;
  }
  .filtre_list .zone_input{
    position:relative;
  }
  .filter_content{
    position: absolute;
    top: calc(100% + 10px);
    z-index: 900;
    border: 1px solid #4c81c0;
    padding: 20px;
    display:flex;
    flex-direction: column;
    width:400px;
    gap:15px;
    background: #FFF;
    left: calc(50% - 200px);
    box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
  -webkit-box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
  -moz-box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
  }

  @media screen and (max-width:990px){
    .filter_content{
      left:-20px;
      right:-20px;
      width:350px;
  }
  }

  .filter_content .value_possible{
    max-height:300px;
    overflow: scroll;
  }
  .filter_content .btn_invert{
    padding:10px;
    color:#4c81c0;
    background:#FFF;
    font-size:12px;
    border-radius: 20px;
    border:1px solid #4C81C0;
  }

  .filter_content .btn{
    padding:10px;
    background:#4c81c0;
    color:#FFF;
    font-size:12px;
    border-radius: 20px;
      border:1px solid #4C81C0;
  }
  .filter_content .flexBottom{
    display: flex;
      gap: 10px;
      flex-wrap: wrap;
  align-self: end;
    margin-top:auto;
    align-items: center;
    width:100%;
  }



  .filtre_list_3{
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    margin-bottom: 20px;
    border-left: 2px solid #CCC;
    padding-left: 20px;
  }
  .filtre_list_2{
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    margin-bottom: 20px;
    /* justify-content: center;*/
    align-items: center;
    flex-grow:1;
  }

  .nb_item{
    background: #B38D2F;
    padding: 2px 10px;
    border-radius: 5px;
    font-size: 10px;
    color:#FFF;
    vertical-align: middle;
    margin-right: 5px;
  }
  .dflex{
    display: flex;
    gap: 10px;
  justify-content: stretch;
  }

  .checkbox{
    position:relative;
  }
  .checkbox_hover{
    background:#FFF;
    font-size:10px;
    display:none;
  }

  .checkboxItem:hover  .checkbox_hover{
    display:block;
  }
  .onecondition{
    width:100%;
    display:block;
  }

  .website{
    color:#4c81c0 !important;
    font-size:14px;
    text-align:center;
    margin-bottom:20px;
    font-weight:700;
  }
  .website a{
    color:#4c81c0 !important;
  }
  .showComments{
    cursor:pointer;
    position:relative;
  }

  .showComments img{
    width:30px;
  }
  .sidePannel{
    position: fixed;
    right: 0;
    width: min(100%,500px);
    background: #FFF;
    top: 0;
    height: 100vh;
    z-index: 999;
    overflow: scroll;

  }

  .oneFilter{
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .oneFilter:not(:last-child){
  border-bottom: 1px solid #ddd;
  }
  .oneFilter .filtreName{
    margin-bottom:10px;
    display:block;
    color:#4c81c0;
  }
  .oneFilter .value_possible{
    max-height:300px;
    overflow: scroll; /* Always show both horizontal and vertical scrollbar */
      scrollbar-width: thin; /* Firefox */
      scrollbar-color: #333 #fff; /* Firefox */
  }

  .oneFilter .value_possible::-webkit-scrollbar {
        width: 12px; /* Width of the scrollbar */
      }

  .oneFilter .value_possible::-webkit-scrollbar-thumb {
        background-color: #333; /* Color of the thumb */
      }
  .oneFilter .value_possible::-webkit-scrollbar-track {
        background-color: #fff; /* Color of the track */
      }

      .sidePannel .filters{
        overflow: scroll;
    padding: 30px;
    height: calc(100vh - 100px);
      }

    .sidePannel .create_filters{
      overflow: scroll;
  padding: 30px;
  height: calc(100vh);
    }
      .footerPannel{
        position: static;
    height: 100px;
    border-top: 2px solid #4c81c0;
    padding:20px;
    text-align:right;
      }

        .footerPannel .btn{
        padding:5px 10px;
        background:#4c81c0;
        color:#FFF;
        font-size:15px;
        border-radius: 20px;
        border:1px solid #4C81C0;
        margin:10px;
      }

      .footerPannel .btn_invert{
      padding:5px 10px;
      color:#4c81c0;
      background:#FFF;
      font-size:15px;
      border-radius: 20px;
      border:1px solid #4C81C0;
      margin:10px;
    }
    .triangle{
      width:15px;
    }

    .triangle.open{
      transform:rotate(180deg);
    }

    .candidate_card.isChecked{
      border-color:#4C81C0;
    }
    .candidate_card.isChecked .checkbox__icon .fond{
      fill:transparent !important;
    }
    .candidate_card:not(.whitehead).isChecked .checkbox__icon .tick{
      stroke:#FFF !important;
    }

    /* .candidate_card.isAssess{
      border-color:#ad8e41;
    } */
    /* .candidate_card.isAssess .candidate_card_head{
      background:#ad8e41;
    } */
  .goRight{
    margin-left:auto;
    display:flex;
    flex-wrap:wrap;
    gap:20px;
  }
  .extraPoolsContainer{
    position:relative;
  }
  .extraPoolsIcons{
    width:20px;
  }
  .extraPoolsNumber{
    background: #B38D2F;
    color: #FFF;
    padding: 0px 6px;
    font-size: 10px;
    font-weight: bold;
    border-radius: 5px;
    position: absolute;
    top: -4px;
    right: -10px;
  }

  .isAssess .extraPoolsNumber{
    color: #B38D2F;
    background: #FFF;
    padding: 0px 6px;
    font-size: 10px;
    font-weight: bold;
    border-radius: 5px;
    position: absolute;
    top: -4px;
    right: -10px;
  }
  .nb_item_comments{
    background: #B38D2F;
    color: #FFF !important;
    padding: 0px 6px;
    font-size: 10px;
    font-weight: bold;
    border-radius: 5px;
    position: absolute;
    top: -4px;
    right: -10px;
  }

  .action_zone{
    position: sticky;
      right: 0;
      top: 0;
      background: #4C81C0;
      padding: 20px 50px;
      z-index:889;
      display:flex;
      flex-wrap:wrap;

  }
  .super_action_zone{
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;
  }
  .actionZoneTitle{
    color: #FFF;
    font-weight: bold;
    font-size: 20px;
      text-transform: uppercase;
  }

  .p-rl-50{
    padding-left:50px;
    padding-right:50px;
  }

  .action_btn,
  .action_btn:hover{
    background: #4c81c0;
    color: #FFF !important;
    padding: 10px 25px !important;
    font-weight: 600;
    border-radius: 200px;
  }
  .back_btn,
  .back_btn:hover{
    background: #FFF;
    color: #000;
    padding: 10px 25px;
    font-weight: 400;
    border-radius: 200px;
  }
  .disabledRlink{
    pointer-events: none;
    opacity: 0.7;
  }

  .zoneBtn{
    position:relative;
    display: flex;
    gap:10px;
    width:100%;
    justify-content: center;
  }


  .whyDisabled{
    position: absolute;
    background: #EFEFEF;
    padding: 5px;
    width: 120px;
    left: 0px;
    bottom: -5px;
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    font-size:12px;
    display:none;
  }

  .enableWhyDisabled:hover .whyDisabled{
    display:block;
  }

  .hoverInfo{
    position: absolute;
    background: #EFEFEF;
    color:#000 !important;
    padding: 5px;
    width: 120px;
    left: 0px;
    bottom: -5px;
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    font-size:12px;
    display:none;
  }

  .extraPoolsContainer:hover .hoverInfo{
    display:block;
  }

  .filter_content_title{
    text-transform:uppercase;
    font-weight:600;
  }

  .v-slider-track__background--opacity {
    opacity: 1;
  }

  .selectAll{
    border: 2px solid #4c81c0;
    padding: 10px 25px;
    border-radius: 200px;
    cursor: pointer;
  }


  [data-tooltip] {
    cursor: pointer;
    display: inline-block;
    line-height: 1;
    position: relative;
    margin-right: auto;
  }
  [data-tooltip]::after {
    background-color: rgba(51, 51, 51, 0.9);
    border-radius: 0.3rem;
    color: #fff;
    content: attr(data-tooltip);
    font-size: 1rem;
    font-size: 85%;
    font-weight: normal;
    line-height: 1.15rem;
    opacity: 0;
    padding: 0.25rem 0.5rem;
    position: absolute;
    text-align: center;
    text-transform: none;
    transition: opacity 0.2s;
    visibility: hidden;
    white-space: nowrap;
    z-index: 1;
  }
  [data-tooltip].tooltip-top::before {
    border-style: solid;
    border-width: 0.3rem;
    content: "";
    opacity: 0;
    position: absolute;
    transition: opacity 0.2s;
    visibility: hidden;
    border-color: rgba(51, 51, 51, 0.9) transparent transparent transparent;
    top: 0;
    left: 50%;
    margin-left: -0.3rem;
  }
  [data-tooltip].tooltip-top::after {
    bottom: 100%;
    left: 50%;
    transform: translate(-50%);
  }
  [data-tooltip].tooltip-bottom::before {
    border-style: solid;
    border-width: 0.3rem;
    content: "";
    opacity: 0;
    position: absolute;
    transition: opacity 0.2s;
    visibility: hidden;
    border-color: transparent transparent rgba(51, 51, 51, 0.9) transparent;
    bottom: 0;
    left: 50%;
    margin-left: -0.3rem;
  }
  [data-tooltip].tooltip-bottom::after {
    top: 100%;
    left: 50%;
    transform: translate(-50%);
  }
  [data-tooltip].tooltip-left::before {
    border-style: solid;
    border-width: 0.3rem;
    content: "";
    opacity: 0;
    position: absolute;
    transition: opacity 0.2s;
    visibility: hidden;
    border-color: transparent transparent transparent rgba(51, 51, 51, 0.9);
    top: 0.3rem;
    right: calc(110% - 0.3rem);
    margin-top: -0.3rem;
  }
  [data-tooltip].tooltip-left::after {
    top: -0.3rem;
    right: calc(110% + 0.3rem);
  }
  [data-tooltip].tooltip-right::before {
    border-style: solid;
    border-width: 0.3rem;
    content: "";
    opacity: 0;
    position: absolute;
    transition: opacity 0.2s;
    visibility: hidden;
    border-color: transparent rgba(51, 51, 51, 0.9) transparent transparent;
    top: 50%;
    top: 0.3rem;
    left: calc(110% - 0.3rem);
    margin-top: -0.3rem;
  }
  [data-tooltip].tooltip-right::after {
    top: -0.3rem;
    left: calc(110% + 0.3rem);
  }
  @media (max-width: 767px) {
    [data-tooltip].tooltip-mobile::before {
      display: none;
    }
    [data-tooltip].tooltip-mobile:after {
      font-size: 1rem;
      max-width: 20rem;
      position: fixed;
      bottom: auto;
      top: 50%;
      left: 50%;
      text-align: left;
      transform: translate(-50%);
      white-space: normal;
    }
  }
  [data-tooltip]:hover::after, [data-tooltip][class*=tooltip-]:hover::before {
    visibility: visible;
    opacity: 1;
  }

  .poolTitle .customH2{
    color:#B38D2F;
  }

  .poolTitle .customH2 .sfname{
    font-weight: 700;
    text-transform:uppercase;
  }

.quicksearch{
  position:relative;
}



  .quicksearch .input{
    max-width:300px;
      border: 1px solid #3783C5;
      background: transparent;
      padding: 10px 20px;
      padding-right: 50px;
      border-radius: 200px;
      outline: none;
      color: #3783C5;
      font-weight: bold;
      letter-spacing: 1px;
  }
  .quicksearch::after{
    content: url('@/assets/loupe.svg');
    position:absolute;
    right:15px;
    top:50%;
    transform:translateY(-50%);
  }


  .slider_mini_score{
    max-width: 350px;
    min-width: 300px;
  }
  @media screen and (max-width:990px){
    .quicksearch{
      max-width: 100%;
      width:100%;
      margin-top:20px;
    }
    .quicksearch .input{
      max-width: 100%;
      width:100%;
        background: transparent;
        padding: 5px 20px;
        border-radius: 200px;
        outline: none;
        font-weight: bold;
        letter-spacing: 1px;
    }
    .filtre_list_2{
      width:100%;
      flex:1;
    }
  }
  .moneyEntryLine{
    width: 100%;

  }
  .moneyEntryName{
      color:#333;
  }
  .moneyEntryInput{
    flex:1;

  }

  .moneyEntryLine select{
    -moz-appearance: menulist;
    -webkit-appearance: menulist;
  }

  .m-rlb-50{
    margin-left: 50px;
    margin-right: 50px;
    margin-bottom: 50px;
  }

  .flexIt > div{
    display:flex;
  }
  .mlauto{
    margin-left: auto;
  }
  .numberRes{
    font-weight: 400;
    color:#3783c5;
  }

  @media screen and (min-width:1301px) and (max-width:1650px){
    .candidate {
      flex: 0 0 auto;
      width: calc(100% / 3);
    }

  }
  @media screen and (min-width:1000px) and (max-width:1300px){
    .candidate {
      flex: 0 0 auto;
      width: 50%;
    }

  }

  .result-list .item{
    padding-left:10px;
  }

  .headline{
    font-size:16px;
    border-bottom:1px solid #CCC;
  }
  .mt50{
    margin-top:50px;
  }
  .mt20{
    margin-top:20px;
  }
  .mb20{
    margin-bottom: 20px;
  }
  .mb50{
    margin-bottom: 50px;
  }
  .actionOnStartups{
    margin-top:20px;
    justify-content: center;
    position: sticky;
      right: 0;
      top: 0;
      z-index:889;
      background:#FFF;
      padding-top:20px;
      padding-bottom: 20px;
  }
  .remove_selected{
    background:#3982C4;
    border:1px solid #3982C4;
    color:#FFF;
    text-align:right;
    margin-left:auto;
    padding:10px 20px;
  }

  .filters_startups{
    display:flex;
    gap:10px;
    margin-top:20px;
    justify-content: space-between;
  }

  .tooglerFilter .toogler{
    color:#3982C4;
    font-weight: 400px;
    display:flex;
    gap:10px;
  }

  .v-img{
    flex:none;
  }

  .inputWithIcon{
    display: flex;
    gap: 20px;
    align-items: center;
  }
  .messageEmail{
    margin-top:50px;
  }

  .right{
    display:flex;
    gap:10px;
  }


  .step-progress {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      margin-bottom: 50px;
      background: #F5FAFF;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 40px;
  padding-right: 40px;
  border-radius: 200px;
  }

  .step {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      position: relative;
  }

  .step-number {
      width: 40px; /* Diameter of the circle */
      height: 40px; /* Diameter of the circle */
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #FFF; /* Green background for active/completed steps */
      color: #000;
      font-weight: bold;
      font-size: 16px;
      border: 2px solid #A1AEBE; /* Border color matches the background */
      position: relative;
      z-index: 1; /* To appear above the connecting lines */
  }

  .step-number.done{
        color: #FFF;
            border: 2px solid #4ADE80; /* Border color matches the background */
                background: #4ADE80; /* Border color matches the background */
  }

  .step-number.active{

        background: #3982C4;
            border: 2px solid #3982C4; /* Border color matches the background */
                color: #FFF; /* Border color matches the background */
  }



  .step-label {
      margin-top: 8px; /* Space between the number and the label */
      font-weight: bold;
      text-align: center;
      color: #333; /* Dark text for the label */
  }

  @media screen and (max-width:990px){
    .step-label{
      display:none;
    }
  }
  .step-line {
      height: 2px; /* Thickness of the line */
      background-color: #b0bec5; /* Light gray color for the connecting line */
      flex: 1; /* Allow the line to take available space */
  }

  .step-line:before {
      content: '';
      position: absolute;
      width: 8px; /* Width of the circle */
      height: 8px; /* Height of the circle */
      border-radius: 50%;
      background-color: #66bb6a; /* Green background for the checkmark */
      top: -3px; /* Adjust position to center the circle on the line */
      left: -4px; /* Adjust position to center the circle on the line */
      display: none; /* Hide initially */
  }

  .step-number.done + .step-line:before {
      display: block; /* Show when step is done */
  }

  .assessment-type {
      display: flex;
      align-items: center;
      margin-bottom:30px;
  }

  .radio-label {
      display: flex;
      align-items: center;
      margin-right: 20px; /* Spacing between options */
      cursor: pointer; /* Change cursor to pointer for better UX */
  }

  input[type="radio"] {
      display: none; /* Hide the default radio button */
  }

  .custom-radio {
      width: 25px; /* Circle diameter */
      height: 25px; /* Circle diameter */
      border: 2px solid #5081C1; /* Light gray border for unselected state */
      border-radius: 50%; /* Make it a circle */
      margin-right: 8px; /* Space between the circle and the text */
      transition: border-color 0.3s, background-color 0.3s; /* Smooth transition for color changes */
  }

  .radio-text {
      font-weight: 600;
      color: #04246A; /* Dark color for the text */
  }

  input[type="radio"]:checked + .custom-radio {
      border-color: #5081C1; /* Change border color when selected */
      background-color: #5081C1; /* Blue background when selected */
  }

  .input_filtre{
    border: 1px solid #4c81c0;
    width: 100%;
    padding: 5px;
    margin-bottom: 20px;

  }

  input[type="checkbox"].customizeCheckbox{
    display:none;
  }
  .custom-checkbox img{
        display:none;
        position: absolute;
  top: 3px;
  left: 3px;
  }

  .custom-checkbox {
      width: 25px; /* Circle diameter */
      height: 25px; /* Circle diameter */
      border: 2px solid #5081C1; /* Light gray border for unselected state */
      border-radius: 0%; /* Make it a circle */
      margin-right: 8px; /* Space between the circle and the text */
      transition: border-color 0.3s, background-color 0.3s; /* Smooth transition for color changes */
  }


  input[type="checkbox"].customizeCheckbox:checked + .custom-checkbox {
      border-color: #5081C1; /* Change border color when selected */
      background:#5081C1;
      position:relative;
  }
  input[type="checkbox"].customizeCheckbox:checked + .custom-checkbox > img{
      display:block;
  }
</style>

<style media="screen">
  .previewNewAssessment .v-slider-thumb__surface.elevation-2{
    border:1px solid rgba(18, 90, 164, 1) !important;
    color: rgba(18, 90, 164, 0.2) !important;
  caret-color: rgba(18, 90, 164, 0.2) !important;
  backdrop-filter: blur(40px);

  }
.previewNewAssessment .v-slider-thumb__ripple{
  color:#FFF !important;
    caret-color:#FFF !important;
}
.previewNewAssessment .v-slider{
  margin-top:40px;
}
.previewNewAssessment .v-slider.v-input--horizontal .v-slider-thumb__label::before{
  display:none;
}
.previewNewAssessment .v-slider-thumb__label{
  background: #FFF;
  color: #BBB;
  border: 1px solid #BBB;
  border-radius: 10px;
}
.previewNewAssessment  .v-slider.v-input--horizontal .v-slider-thumb__label{
  bottom:10px;
}
.previewNewAssessment .v-slider-track__background{
  background-color: #E1E1E1 !important;
  opacity: 1;
}
.previewNewAssessment  .v-slider .v-input__control{
  margin-left:10px;
  margin-right: 10px;
}

.rmbtn{
  display: block;
  background: #4c81c0;
  color: #FFF !important;
  padding: 10px 25px !important;
  font-weight: 600;
  border-radius: 200px;
}

.rm{
  display: block;
  background: transparent;
  color: #FFF;
  text-align: center;
}
.rmjudge{

}

.actionOnStartups .selectAll{
  margin:0px;
}

.boldblue{
  color: #04246A;
  font-weight: 600;
}

.groupSelectorAllValuesBtnLabel{
  padding: 3px 10px;
    border: 1px solid #5081C1;
    border-radius: 200px;
    background: #5081C1;
    color: #FFF;
        cursor:pointer;
}

.putbtn-center button{
  margin:auto;
}

.footer .detail{
  margin-left: auto;
}

@media screen and (min-width:1200px) and (max-width:1450px){
  .candidateList{
    width:calc(100% / 3);
  }
}
</style>
